import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { environment } from "../../../environments/environment";
import { appService } from "../../_services/app.service";
import { ToastrService } from "ngx-toastr/";
import { ScriptLoaderService } from "../../_services/script-loader.service";
import { CommonService } from "../../_services/common.service";
declare var jquery: any;
declare var $: any;
declare var Dropzone: any;
declare var moment: any;
import { HttpClient } from "@angular/common/http";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { AlertService } from "../../auth/_services";
import { DatePipe } from "@angular/common";
import { Observable } from "rxjs/Observable";
import { Router, ActivatedRoute } from "@angular/router";
import { JSONP_ERR_NO_CALLBACK } from "@angular/common/http/src/jsonp";
import { Helpers } from "../../helpers";
import { NavService } from "../../_services/NavService.service";
import { string } from "@amcharts/amcharts4/core";
import { DocumentsComponent } from "../../../app/documentshared/documents.component";
import { NtwCardComponent } from "../ntw-card/ntw-card.component";
import { TranslateConfigService } from "../../theme/home/translateConfig.service";
import { TranslateService } from "@ngx-translate/core";
import { e } from "@angular/core/src/render3";
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: "app-network",
  templateUrl: "./network.component.html",
  styleUrls: ["./network.component.scss"],
})
export class NetworkComponent implements OnInit, AfterViewInit {
  static that: NetworkComponent;
  enableUlipForGSTIN: boolean = false;
  gstinData: any;
  static networkComponent: NetworkComponent;
  Data: any = null;
  toggle = "list";
  datatable;
  Networkdatatable;
  carrierDatatable;
  PincodeDatatable;
  ContactsDatatable;
  ProductDataTable;
  AccountDetailsDatatable;
  TranshipmentDatatable;
  ContractDatatable;
  CompanyBrnachDatatable;
  CompanySubCompanyDatatable;
  EditContractDatatable;

  isValidGST: boolean = true;
  CompanyType: any = [];
  TaxExemptionReason: any = [];
  model: any = {};
  selectedLang: string;
  public showNetworkDetails: boolean = false;
  public myVar: boolean = true;
  public myVar1: boolean = false;
  public Company: any = {};
  transportTypesList: any = [];
  DefaultNetworkAccountsType: any = [];
  OfficialAddress: any = {};
  CompanyAddress: any = {};
  BillingAddress: any = {};
  Pincode: any = {};
  CompanyId: any = '';
  Contacts: any = {};
  AccountDetail: any = {};
  EscalationList: any = [];
  NetworkCompanyId: any = {};
  registrationTypeList: any = [];
  IsNetworkCompany: any = {};
  Social: any = {};
  Infrastructure: any = {};
  CompanyInfrastructures: any = {};
  oFileIn: any = {};
  TransshipmentPointModel: any = {};
  NewNetwork: any = {};
  public EditName: string;
  CompanyFullName: string;
  public OnContract: boolean = true;
  public OffContract: boolean = false;
  CarrierContractMaster: any = {};
  demo;
  DefaultDatatableDemo;
  EditContract: any = {};
  EditD2D: any = null;
  carrierContractMasterId: any;
  ValueType: any = [];
  ContractStatus: any = [];
  public ContractScreen: boolean = true;
  public ContractsList: boolean = false;
  ApplybyUnitList: any = [];
  Id: any = {};
  CityName: any = [];
  CityNameForRate: any = [];
  CityTranshipment: any = [];
  percentage: Observable<number>;
  snapshot: Observable<any>;
  downloadURL: Observable<string>;
  isHovering: boolean;
  flag: boolean;
  ManageTdsList: any = [];
  TenantId: any;
  SalesPerson: any;
  TimeDivision: any = [];
  OtherDetails: any = {};
  AccountData: any = {};
  showTDSDropdown: any = false;
  SystemVersion: any;
  select2: string = "All";
  NetworkType: string = "All";
  ShowAttachment: any = false;
  warehouseSelectFile: any = {};
  userId: any;
  SalesFlag: boolean = false;//Add By Ketan on 16-Oct-2020
  smsFlag: boolean = true;//Add By Ketan on 16-Oct-2020
  hubAndSpokeFlag: boolean = false;
  //add kevin 27/10/2020
  isTransporter: boolean = false;
  isCustomer: boolean = false;
  //end
  ExemptionReasonText = "";
  OneToTwenty: any = false;
  TwentyoneToForty: any = false;
  FortyoneToSixty: any = false;
  AboveSixty: any = false;
  checkCompanyType: any = '';
  hostUrl: any = environment.apiUrl;
  isOpenInOtherPage = false;
  isOpenWarehouse = false;
  CustomerConversionFactorList: any = [];
  isHotShotshostUrl: any = environment.apiUrl == 'https://nol.ifreightbox.net/' ? true : false;

  @ViewChild(DocumentsComponent) AttachmentChild: DocumentsComponent;
  @ViewChild(NtwCardComponent) NtwCardChild: NtwCardComponent;
  loading: boolean;

  //add vithujan 12-08-2022
  CompanyMasterType: any = {};
  //end
  //added by vithujan 26-12-2022
  NetworkId: any;
  //end
  cb_isDefault: any = false;
  //added by vithujan 14-01-2023
  DeliveryPartnerList: any;
  //end
  //added by vithujan 08-05-2023
  hideHeader: boolean = false;
  networkSelectFile: any = {};
  //enableUlipForGSTIN: boolean = false;
  //added by rahul
  shipmentAllocationRule: any = [];
  //end
  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _script: ScriptLoaderService,
    private http: HttpClient,
    private cookieservice: CookieService,
    private anghttp: Http,
    public datepipe: DatePipe,
    private commonService: CommonService,
    private route: Router,
    private router: ActivatedRoute,
    private _navService: NavService,
    private cookieService: CookieService,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private decryptpipe: DecryptPipe
  ) {
    NetworkComponent.networkComponent = this;

    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.GetUlipSetting();
    var Id = "";
    this.router.params.subscribe((params) => {
      Id = params["Id"];
    });
    this.GetCompanyType();
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.SystemVersion = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SystemVersion")));
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    //add kevin 27/10/2020
    this.isTransporter = JSON.parse(localStorage.getItem("isTransporter"));
    this.isCustomer = JSON.parse(localStorage.getItem("isCustomer"));
    //end
    this.SalesFlag = JSON.parse(localStorage.getItem("SalesFlag"));
    this.RefreshvalidDate();
    this.DataTableNetwork();
    this.GetTransportService();
    this.GetDefaultNetworkAccountsType();
    this.GetEscalationService();
    //this.GetRegistration();
    this.GetTaxExemptionReason();
    this.DataTableCarrier();
    this.GetValueType();
    this.GetContractStatus();
    this.GetApplybyUnitList();
    this.GetOfficialSelectData();
    this.GetBillingSelectData();
    this.GetTimeDivision();
    this.GetSelectData();
    this.GetManageTds();
    //added by vithujan 21-07-2023
    this.GetAccountList();
    this.GetUlipSetting();

    this.RefreshvalidTimePicker();
    this.GetDeliveryTimeWindowSelectData();

    // setTimeout(() => {
    //     this._navService.navItem$
    //         .subscribe(item => {
    //             Helpers.setLoading(true);
    //             this.TenantId = JSON.parse(localStorage.getItem('ChnageCompnayId')).TenantId;
    //             if (NetworkComponent.networkComponent.Networkdatatable)
    //                 NetworkComponent.networkComponent.Networkdatatable.destroy();

    //             this.DataTableNetwork();
    //             Helpers.setLoading(false);
    //         })
    // }, 500);
    if (Id != "list" && Id != undefined && Id != "" && Id != null) {
      this.GetNetworkById(Id);
    }
    //Add By Ketan on 16-Oct-2020
    this.SalesFlag = JSON.parse(localStorage.getItem("SalesFlag"));
    if (this.SalesFlag == true) {
      $("#ReverseChargeMechanism").hide()
      $("#TDSPreference").hide()
      $("#eWayBill").hide()
      $("#PermitNumber").hide()
      $("#SelectApplicableTDS").hide()
    }
    else {
      $("#ReverseChargeMechanism").show()
      $("#TDSPreference").show()
      $("#eWayBill").show()
      $("#PermitNumber").show()
      $("#SelectApplicableTDS").show()
    }
    this.smsFlag = JSON.parse(localStorage.getItem("smsFlag"));
    this.hubAndSpokeFlag = JSON.parse(localStorage.getItem("hubAndSpokeFlag"));
    //Ended By Ketan on 16-Oct-2020

  }
  ngAfterViewInit() {
    $("#DriverAttchment").on("shown.bs.modal", function () {
      NetworkComponent.networkComponent.OnAttachmentClick();
    });
  }

  GoBack() {
    this.model = {};
    this.showNetworkDetails = false;
    this.myVar = true;
    this.myVar1 = false;
    this.Company = {};
    this.OfficialAddress = {};
    this.CompanyAddress = {};
    this.BillingAddress = {};
    this.Pincode = {};
    // this.CompanyId = {};
    this.Contacts = {};
    this.AccountDetail = {};
    this.NetworkCompanyId = {};
    this.registrationTypeList = [];
    this.IsNetworkCompany = {};
    this.Social = {};
    // add kevin 27-Dec-2021
    this.Infrastructure = {};
    this.CompanyInfrastructures = {};
    // end
    this.oFileIn = {};
    this.TransshipmentPointModel = {};
    this.NewNetwork = {};
    this.EditName = "";
    this.CompanyFullName = "";
    this.OnContract = true;
    this.OffContract = false;
    this.CarrierContractMaster = {};
    this.EditContract = {};
    this.EditD2D = null;
    this.carrierContractMasterId = "";
    this.ContractScreen = true;
    this.ContractsList = false;
    this.Id = {};
    this.CityName = [];
    this.CityNameForRate = [];
    this.CityTranshipment = [];
    this.percentage = new Observable<number>();
    this.snapshot = new Observable<any>();
    this.downloadURL = new Observable<string>();
    this.isHovering = false;
    this.flag = false;
    this.TenantId;
    this.OtherDetails = {};
    this.AccountData = {};
    this.showTDSDropdown = false;
    this.SystemVersion = "";

    if (this.toggle == "list") this.DataTableNetwork();
    if (this.toggle == "card") this.GetNetworkCardData();

    this.RefreshParentCompany();
    this.DataTableCarrier();

    if ($("#se2_DeliveryPartner_net").select2()) {
      $("#se2_DeliveryPartner_net").val("");
      $("#se2_DeliveryPartner_net").select2("destroy");
    }

    $("#LUTBondStartDate").val("");
    $("#LUTBondEndDate").val("");

    $("#NetworkAccountsType").val("");
    $("#NetworkAccountsType").select2("destroy");
    this.GetSelectData();

    $("#NCompanyCountry").val("");
    $("#NCompanyCountry").select2("destroy");
    $("#NCompanyState").val("");
    $("#NCompanyState").select2("destroy");
    $("#NCompanyCity").val("");
    $("#NCompanyCity").select2("destroy");
    this.GetOfficialSelectData();

    $("#NCompanyCountryBilling").val("");
    $("#NCompanyCountryBilling").select2("destroy");
    $("#NCompanyStateBilling").val("");
    $("#NCompanyStateBilling").select2("destroy");
    $("#NCompanyCityBilling").val("");
    $("#NCompanyCityBilling").select2("destroy");
    this.GetBillingSelectData();

    $(".ClsTypeOfService").prop("checked", false);
    this.ClearBasicInfoValidation();
    $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
    $(
      "#divtopbar_OtherDetails, #divtopbar_address,#divtopbar_contacts,#divtopbar_bankaccounts,#divtopbar_registration,#divtopbar_Social,#divtopbar_TranshipmentPoint,#divtopbar_pincode,#divtopbar_Contract,#divtopbar_Infrastructure,#divtopbar_Branch,#divtopbar_SubCompany,#divtopbar_Accounts , #divtopbar_Shipmentallocaitonrule"
    ).removeClass("active");
    $(
      "#topbar_OtherDetails, #topbar_address,#topbar_contacts,#topbar_bankaccounts,#topbar_registration,#topbar_social,#topbar_TranshipmentPoints,#topbar_pincode,#topbar_Contract,#topbar_Infrastructure,#topbar_Branch,#topbar_SubCompany,#topbar_Accounts ,#topbar_Shipmentallocaitonrule"
    ).removeClass("active");

    if (this.isOpenInOtherPage === false) {
      this.route.navigate(["/network", "list"]);
    }
  }

  GetNetworkCardData() {
    this.NtwCardChild.NetworkSearchData = {};
    this.NtwCardChild.NetworkSearchData.Status = this.NetworkType;
    this.NtwCardChild.NetworkSearchData.TenantId = this.TenantId;
    this.NtwCardChild.NetworkSearchData.Search = $("#NetworkSearch").val();
    this.NtwCardChild.GetNetworkCardData();
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  startUpload(event: FileList) {
    const file = event.item(0);
    // Client-side validation example
    if (file.type.split("/")[0] !== "image") {
      console.error("unsupported file type :( ");
      return;
    }
  }
  onChange(st: string) {
    this.toggle = st;
    if (st == "list") this.Networkdatatable.search(this.NetworkType, "Status");
    if (st == "card") this.GetNetworkCardData();
  }

  SearchStatus(Status, d) {
    this.select2 = d;
    this.NetworkType = Status;
    if (this.toggle == "list") this.Networkdatatable.search(Status, "Status");
    if (this.toggle == "card") this.GetNetworkCardData();
  }

  GetTaxExemptionReason() {
    this._appService.Get("Company", "GetTaxExemptionReason").subscribe(
      (response) => {
        this.TaxExemptionReason = response;
        // this.RefreshParentCompany();
        setTimeout(() => {
          (<any>$("#ExemptionReason")).selectpicker("refresh");
        }, 100);
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  GetManageTds() {
    this._appService.Get("Company", "GetTdsList").subscribe(
      (response) => {
        this.ManageTdsList = response;
        this.RefreshParentCompany();
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
      }
    );
  }

  GetCompanyType() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "CompanyType")
      .subscribe(
        (response) => {
          this.CompanyType = response;
          this.RefreshParentCompany();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Company Type Data !",
            "error"
          );
        }
      );
  }

  // --------------getList code------------------------

  GetTransportService() {
    this._appService
      .Get("Company", "GetTransportTypesList")
      .subscribe((response) => {
        this.transportTypesList = response;
        setTimeout(() => {
          $("#CompanyTransport_0").prop("checked", "checked");
        }, 350);
      });
  }

  GetEscalationService() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "EscalationLevel")
      .subscribe((response) => {
        this.EscalationList = response;
        this.RefreshParentCompany();
      });
  }

  GetTimeDivision() {
    this._appService
      .GetById("Common", "GetLookByCategoryName", "TimeDivision")
      .subscribe((response) => {
        this.TimeDivision = response;
        this.RefreshParentCompany();
      });
  }

  GetRegistrationData() {
    if ($("#NCompanyCountry").val() != null) {
      this._appService
        .GetByTwoId(
          "Common",
          "GetLookByCategoryNameAndParent",
          "RegistrationDocuments",
          $("#NCompanyCountry").val()
        )
        .subscribe(
          (response) => {
            this.registrationTypeList = response;
            this.RefreshvalidDate();
          },
          (err) => {
            this.toastr.error(
              "Error occurred while getting registration data !",
              "error"
            );
          }
        );
    }
  }

  GetValueType() {
    this._appService.Get("Carrier", "GetValueType").subscribe((response) => {
      this.ValueType = response;

      this.RefreshParentCompany();
    });
  }

  GetApplybyUnitList() {
    this._appService
      .Get("Network", "GetApplybyUnitList")
      .subscribe((response) => {
        this.ApplybyUnitList = response;
        this.RefreshParentCompany();
      });
  }

  RefreshvalidDate() {
    setTimeout(() => {
      $(".datepicker").datepicker({
        todayHighlight: !0,
        orientation: "auto",
        autoclose: true,
        format: "dd/mm/yyyy",
        templates: {
          leftArrow: '<i class="la la-angle-left"></i>',
          rightArrow: '<i class="la la-angle-right"></i>',
        },
      });
    }, 1000);
  }

  RefreshParentCompany() {
    setTimeout(function () {
      (<any>$("#EscalationLevel")).selectpicker("refresh");
      (<any>$("#ValueType")).selectpicker("refresh");
      (<any>$("#ContractStatus")).selectpicker("refresh");
      (<any>$("#ApplybyUnit")).selectpicker("refresh");
      (<any>$("#RatesTemplate")).selectpicker("refresh");
      (<any>$("#TimeDivision")).selectpicker("refresh");
      (<any>$("#ExemptionReason")).selectpicker("refresh");
      (<any>$("#CompanyType")).selectpicker("refresh");
      (<any>$("#TDSDropdown")).selectpicker("refresh");
    });
  }

  GetContractStatus() {
    this._appService
      .Get("Carrier", "GetContractStatus")
      .subscribe((Response) => {
        this.ContractStatus = Response;
      });
  }
  // ---------------------Save code-------------------------

  SaveBasicInfo(ToDo) {
    if (!this.ValidateBasicInfoField()) {
      return false;
    }
    //add trupti 04-feb-2022
    $("#BtnAuthorizeNetwork").prop("disabled", false);
    //end
    Helpers.setLoading(true);
    let SelectedTransportIds = [];
    this.transportTypesList;

    $("[name='CompanyTransport[]']:checked").each(function () {
      SelectedTransportIds.push($(this).val());
    });

    this.Company.TransportIds = SelectedTransportIds;
    this.Company.IsNetworkCompany = true;

    let x = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole"))).split(",");
    var userRole = x;
    var userRole1 = $.parseJSON(userRole);
    this.Company.TenantId = $.parseJSON(
      this.decryptpipe.transform($.parseJSON(this.cookieservice.get("TenantId")))
    );
    this.Company.AccountTypeId = $("#NetworkAccountsType").val();
    // this.Company.SalesPerson = $("#SalesPerson").val();
    // this.Company.SalesPersonName = $("#SalesPersonName").text();
    this.SaveCompany(ToDo);

    Helpers.setLoading(false);
  }

  AddressTypechangeEvent(IsSame) {
    if (this.CompanyAddress.IsSame == true) {
      this.BillingAddress.UnitNo = this.OfficialAddress.UnitNo;
      this.BillingAddress.Address = this.OfficialAddress.Address;
      this.BillingAddress.PostalCode = this.OfficialAddress.PostalCode;

      this.BillingAddress.FloorNo = this.OfficialAddress.FloorNo;
      this.BillingAddress.FlatNo = this.OfficialAddress.FlatNo;
      this.BillingAddress.LandMark = this.OfficialAddress.LandMark;
      this.BillingAddress.ContactPerson = this.OfficialAddress.ContactPerson;
      this.BillingAddress.Phone = this.OfficialAddress.Phone;
      this.BillingAddress.Email = this.OfficialAddress.Email;

      let Country = "";
      Country =
        '<option value="' +
        $("#NCompanyCountry").val() +
        '">' +
        $("#NCompanyCountry").val() +
        "</option>";
      $("#NCompanyCountryBilling").html(Country);
      $("#NCompanyCountryBilling").val($("#NCompanyCountry").val()).change();

      let State = "";
      State =
        '<option value="' +
        $("#NCompanyState").val() +
        '">' +
        $("#NCompanyState").val() +
        "</option>";
      $("#NCompanyStateBilling").html(State);
      $("#NCompanyStateBilling").val($("#NCompanyState").val()).change();

      let City = "";
      City =
        '<option value="' +
        $("#NCompanyCity").val() +
        '">' +
        $("#NCompanyCity").val() +
        "</option>";
      $("#NCompanyCityBilling").html(City);
      $("#NCompanyCityBilling").val($("#NCompanyCity").val()).change();
    } else {
      this.BillingAddress.UnitNo = "";
      this.BillingAddress.Address = "";
      this.BillingAddress.PostalCode = "";
      $("#NCompanyCountryBilling").val("");
      $("#NCompanyStateBilling").val("");
      $("#NCompanyCityBilling").val("");
      this.GetBillingSelectData();
    }
  }

  SaveContact() {
    if (!this.ValidateContact()) {
      return false;
    }
    Helpers.setLoading(true);
    this.Contacts.CompanyId = this.Company.Id;
    // this.Contacts.NetworkComapnyId
    this.Contacts.EscalationLevel = $("#EscalationLevel").val();
    this.Contacts.IsNetworkCompany = true;
    // this.Contacts.CompanyId = this.CompanyId;
    this._appService.Post("Company", "SaveContact", this.Contacts).subscribe(
      (response) => {
        $("#newContact").modal("hide");
        // $("#divtopbar_address,#divtopbar_companyInfo, #divtopbar_contacts, #divtopbar_registration, #divtopbar_social, #divtopbar_summary, #topbar_companyInfo, #topbar_address, #topbar_contacts, #topbar_registration, #topbar_social, #topbar_summary").removeClass("active");
        // $("#divtopbar_financials, #topbar_financials").addClass("active");

        this.GetContactsList(this.Contacts.CompanyId);
        NetworkComponent.networkComponent.ContactsDatatable.reload();
        this.toastr.success("Contact data saved Successfully !", "Success");
        // CompanyComponent.companyComponent.GetContactsList();
      },
      (err) => {
        this.toastr.error(
          "Error occurred while saving Contact data !",
          "error"
        );
      }
    );
    Helpers.setLoading(false);
    // this.loading = false;
  }

  //Added By Ketan on 26-Oct-2020

  CheckRFCNO(ctrl, ValidationPosition) {
    const validRFCNO = this.translate.instant("SIGNUP.validRFCNO");
    var regex = /^[A-Z]{4}\d{6}[A-Z0-9]{3}$/;
    if (regex.test(ctrl) == true) {
      return true;
    }
    else {
      $(ctrl).closest(".form-group").addClass("has-error");
      this.loading = false;
      this.toastr.warning(validRFCNO, "Warning");
      return false;
    }

  }
  //Ended By Ketan on 26-Oct-2020

  SaveRegistration() {

    //Added By Ketan on 26-Oct-2020
    const RFCNoEmpty = this.translate.instant("SIGNUP.RFCNo Empty");//Add By Ketan on 24-Oct-2020
    //
    for (let i = 0; i < this.registrationTypeList.length; i++) {
      // if (this.registrationTypeList[i].Number == '') {
      //   this.toastr.error(RFCNoEmpty, "Warning");
      //   this.loading = false;
      //   return;
      // }
      // else
      if (this.registrationTypeList[i].Label == 'GST1 (15 digit)' || this.registrationTypeList[i].Label == 'GST2 (15 digit)' || this.registrationTypeList[i].Label == 'RFC No') {
        if ($("#NCompanyCountry").val() == 'India') {
          if (!this.CheckGSTCNO(this.registrationTypeList[i].Number, "after")) {
            return;
          }
        }
        if ($("#NCompanyCountry").val() == 'Mexico') {
          if (!this.CheckRFCNO(this.registrationTypeList[i].Number, "after")) {
            return;
          }
        }
      }

    }

    //Added By Ketan on 26-Oct-2020

    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      Helpers.setLoading(true);
      var _that = this.Company.Id;
      try {
        this.registrationTypeList.forEach((element, index) => {
          element.DocumentId = element.Id;
          element.CompanyId = this.Company.Id;
          element.IsNetworkCompany = true;
          if (
            $("#NValidity_" + index).val() != undefined &&
            $("#NValidity_" + index).val() != null
          ) {
            element.Validity = $("#NValidity_" + index)
              .data("datepicker")
              .getFormattedDate("yyyy/mm/dd");
          }

        });

        this._appService
          .Post("Company", "SaveRegistration", this.registrationTypeList)
          .subscribe(
            (response) => {
              this.toastr.success(
                "Registration data saved Successfully !",
                "Success"
              );
              //added by vithujan 26-12-2022
              this.GetNetworkById(this.NetworkId);
            },
            (err) => {
              this.toastr.error(
                "Error occurred while saving Registration Data !",
                "error"
              );
            }
          );
        $(
          "#divtopbar_registration,#topbar_registration,#divtopbar_companyInfo,#divtopbar_address,#divtopbar_contacts,divtopbar_registration, #divtopbar_TranshipmentPoint,#divtopbar_pincode,#divtopbar_Contract,#divtopbar_NewContract,#topbar_companyInfo,#topbar_address,#topbar_contacts,#topbar_registration,#topbar_pincode,#topbar_TranshipmentPoints,#topbar_Contract,#topbar_NewContract"
        ).removeClass("active");
        $("#divtopbar_Social,#topbar_social").addClass("active");
      } catch (error) {
        this.toastr.error(
          "Error occurred while saving Registration Data !",
          error
        );
      }
      Helpers.setLoading(false);
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_registration, #topbar_registration").removeClass("active");
    }
  }

  SaveSocial() {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      Helpers.setLoading(true);
      try {
        this.Social.CompanyId = this.Company.Id;
        this.Social.IsNetworkCompany = true;
        this._appService.Post("Company", "SaveSocial", this.Social).subscribe(
          (response) => {
            $(
              "#divtopbar_companyInfo,#divtopbar_address,#divtopbar_contacts,#divtopbar_Social,divtopbar_registration,#divtopbar_pincode,#divtopbar_Contract,#divtopbar_NewContract,#topbar_companyInfo,#topbar_address,#topbar_contacts,#topbar_registration,#topbar_pincode,#topbar_TranshipmentPoints,#topbar_Contract,#topbar_NewContract,#topbar_social"
            ).removeClass("active");
            $(
              "#divtopbar_TranshipmentPoint,#topbar_TranshipmentPoints"
            ).addClass("active");
            this.GetTranshipmentPonitList(this.EditD2D);
            this.toastr.success("Social data saved Successfully !", "Success");
          },
          (err) => {
            this.toastr.error(
              "Error occurred while saving Social Data !",
              "error"
            );
          }
        );
      } catch (error) {
        this.toastr.error("Error occurred while Saving Social Data !", error);
      }
      Helpers.setLoading(false);
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_Social, #topbar_social").removeClass("active");
    }
  }

  // add kevin 27-Dec-2021
  SaveInfrastructure() {
    if (this.Company.Id != null && this.Company.Id != undefined && this.Company.Id != "") {
      Helpers.setLoading(true);
      try {
        this.Infrastructure.CompanyId = this.Company.Id;
        this.Infrastructure.forEach(element => {
          if (element.Comment == '1 T') {
            element.Fleets = this.CompanyInfrastructures.Fleet1t;
          }
          if (element.Comment == '3.5 T') {
            element.Fleets = this.CompanyInfrastructures.Fleet35t;
          }
          if (element.Comment == '8 T') {
            element.Fleets = this.CompanyInfrastructures.Fleet8t;
          }
        });
        this.Infrastructure.forEach(element => {
          if (element.Comment == '1-20') {
            element.Fleets = this.OneToTwenty;
          }
          if (element.Comment == '21-40') {
            element.Fleets = this.TwentyoneToForty;
          }
          if (element.Comment == '41-60') {
            element.Fleets = this.FortyoneToSixty;
          }
          if (element.Comment == '+60') {
            element.Fleets = this.AboveSixty;
          }
        });
        this._appService.Post("Company", "SaveInfrastructure", this.Infrastructure).subscribe(
          (response) => {
            $(
              "#divtopbar_Infrastructure,#topbar_Infrastructure"
            ).removeClass("active");
            $(
              "#divtopbar_companyInfo,#topbar_companyInfo"
            ).addClass("active");
            this.toastr.success("Infrastructure data saved Successfully !", "Success");
          },
          (err) => {
            this.toastr.error("Error occurred while saving Infrastructure Data !", "error");
          }
        );
      } catch (error) {
        this.toastr.error("Error occurred while Saving Infrastructure Data !", error);
      }
      Helpers.setLoading(false);
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_Infrastructure,#topbar_Infrastructure").removeClass("active");
    }
  }
  // end

  TransshipmentPoint() {
    Helpers.setLoading(true);
    var flag = this.ValidateTransshipmentPoint();
    if (flag != false) {
      this.TransshipmentPointModel.CompanyId = this.Company.Id;
      this.TransshipmentPointModel.OwnershipId = $("#SelectTranshipOwnership").val();
      this.TransshipmentPointModel.PickupBranch = $("#se2_ctpPickupBranch").val();
      this.TransshipmentPointModel.DeliveryBranch = $("#se2_ctpDeliveryBranch").val();
      this.TransshipmentPointModel.DeliveryFromTimeWindow = this.timeConvert($("#in_DeliveryFromTimeWindow").val());
      this.TransshipmentPointModel.DeliveryToTimeWindow = this.timeConvert($("#in_DeliveryToTimeWindow").val());
      this._appService
        .Post("Carrier", "SaveCarrierData", this.TransshipmentPointModel)
        .subscribe(
          (response) => {
            $("#newTransshipment").modal("hide");
            this.GetTranshipmentPonitList(
              this.TransshipmentPointModel.CompanyId
            );
            NetworkComponent.networkComponent.ClearWareHoueseValidation();
            NetworkComponent.networkComponent.TranshipmentDatatable.reload();
            this.toastr.success(
              "Transshipment data saved Successfully !",
              "Success"
            );
          },
          (err) => {
            this.toastr.error(
              "Error occurred while saving Contact data !",
              "error"
            );
          }
        );
    } else {
      this.toastr.error("Please Fill Required Details ", "Error");
    }
    Helpers.setLoading(false);
  }

  GetCustomerVendorSelect2Data() {
    $("#SelectTranshipOwnership").select2({
      tags: true,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Network/GetNetworkDataByOwnership",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
            TenantId: NetworkComponent.networkComponent.TenantId,
            OwnershipType: $("#TranshipOwnership").val(),
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],
      createTag: function (params) {
        $(".select2-search__field").keydown(function (e) {
          if (e.keyCode != 32) {
            var term = $.trim(params.term);
            // Don't offset to create a tag if there is no valid email
            return {
              id: term,
              text: term,
              newTag: true, // add additional parameters
            };
          }
        });
      },
      insertTag: function (data, tag) {
        data.push(tag);
      },
      placeholder: "Enter Customer/vendor Name",
    });

    $("#se2_ctpPickupBranch").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/getBranchList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: params.term
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search Pickup Branch",
    });
    $("#se2_ctpPickupBranch").on("select2:select", function (e) {
      var data = e.params.data;
      // NetworkComponent.networkComponent.TransshipmentPointModel.PickupBranch = data.id;
    });

    $("#se2_ctpDeliveryBranch").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/getBranchList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: params.term
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search Delivery Branch",
    });

    $("#se2_ctpDeliveryBranch").on("select2:select", function (e) {
      var data = e.params.data;
      // NetworkComponent.networkComponent.TransshipmentPointModel.DeliveryBranch = data.id;
    });
  }

  ValidateContact() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#ContactFullName"),
        "Please Enter Contact Full Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#PhoneNo"),
        "Please Phone No",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#MobileNo"),
        "Please Enter Mobile No.",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#Email"),
        "Please Enter Email",
        "after",
        ""
      )
    ) {
      flag = false;
    } else {
      if (!this.commonService.CheckEmail($("#Email"), "after")) {
        flag = false;
      }
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#Designation"),
        "Please Enter Designation",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#LocationDesc"),
        "Please Enter Location/Descreption",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    return flag;
  }

  ClearValidateContact() {
    this.commonService.ClearMessage($("#ContactFullName"));
    this.commonService.ClearMessage($("#PhoneNo"));
    this.commonService.ClearMessage($("#MobileNo"));
    this.commonService.ClearMessage($("#Email"));
    this.commonService.ClearMessage($("#Designation"));
    this.commonService.ClearMessage($("#LocationDesc"));
  }

  ClearWareHoueseValidation() {
    this.commonService.ClearMessage(
      $("#TransshipmentPointModelContactFullName")
    );
    this.commonService.ClearMessage($("#TransshipmentPointName"));
    this.commonService.ClearMessage($("#TransshipmentPointModelOfficeCity"));
    this.commonService.ClearMessage($("#TransshipmentPointModelTown"));
    this.commonService.ClearMessage($("#TransshipmentPointModelDesignation"));
    this.commonService.ClearMessage($("#TransshipmentPointModelLocationDesc"));
    this.commonService.ClearMessage($("#TransshipmentPointModelPostalCode"));
    this.commonService.ClearMessage($("#FieldSetTransshipOwnershipType"));
  }

  ValidateTransshipmentPoint() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointModelContactFullName"),
        "Please Tranship Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointName"),
        "Please Insert Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointModelOfficeCity"),
        "Please Insert Address",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointModelTown"),
        "Please Insert Town/City",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointModelDesignation"),
        "Please Insert State",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointModelLocationDesc"),
        "Please Insert Country",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#TransshipmentPointModelPostalCode"),
        "Please Insert Postal Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField2(
        $("#TranshipOwnership"),
        $("#FieldSetTransshipOwnershipType"),
        "Please Select Ownership Type",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      $("#TranshipOwnership").val() == "Customer" ||
      $("#TranshipOwnership").val() == "Vendor"
    ) {
      if (
        !this.commonService.ValidateRequiredField2(
          $("#SelectTranshipOwnership"),
          $("#FieldSetTransshipOwnership"),
          "Please Select Ownership Type",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    } else {
      this.commonService.ClearMessage($("#FieldSetTransshipOwnership"));
    }

    return flag;
  }

  RefreshTranshipmentDropdown() {
    setTimeout(() => {
      (<any>$("#TranshipOwnership")).selectpicker("refresh");
      (<any>$("#DeliveryType")).selectpicker("refresh");
      (<any>$("#se_CustomerType")).selectpicker("refresh");
    }, 100);
  }

  RefreshSelect2() {
    $("#SelectTranshipOwnership").val("");
    $("#SelectTranshipOwnership").select2("destroy");
    $("#se2_ctpPickupBranch").val("");
    $("#se2_ctpPickupBranch").select2("destroy");
    $("#se2_ctpDeliveryBranch").val("");
    $("#se2_ctpDeliveryBranch").select2("destroy");
    this.GetCustomerVendorSelect2Data();
  }

  selectFile: any;
  company: any;
  upload(event) {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      Helpers.setLoading(true);
      this.selectFile = event.target.files[0];

      //--------------File True Type Validation ---------- added by vithujan 22-09-2022
      var fileReader = new FileReader();
      var isValidFileType = true;
      fileReader.onloadend = function (e: any) {
        var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
        var header = "";

        for (var i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
        if (header.toUpperCase() != 'D0CF11E0' && header.toUpperCase() != '504B34' && header.toUpperCase() != '43686172' && header.toUpperCase() != '5472616E') {
          NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.CSVXLS"), 'Error');
          $("#PincodeUpload").val("");
          isValidFileType = false;
          Helpers.setLoading(false);
          return false;
        }
      };
      fileReader.readAsArrayBuffer(this.selectFile);
      //----------------------------------------------

      setTimeout(() => {
        if (isValidFileType == true) {
          //--------------Filename Validation ---------- added by vithujan 23-09-2022
          var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
          if (!format.test(this.selectFile.name)) {
            this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
            $("#PincodeUpload").val("");
            Helpers.setLoading(false);
            return false;
          }
          //--------------File Type Validation ---------- added by vithujan 16-09-2022
          var meme_type = this.selectFile.type;
          if ((meme_type.toLowerCase() != "text/csv") && (meme_type.toLowerCase() != "application/vnd.ms-excel")) {
            this.toastr.error(this.translate.instant("SETTING.CSVXLS"), 'Error');
            $("#PincodeUpload").val("");
            Helpers.setLoading(false);
            return;
          }

          //--------------Size Validation----------------
          var bytesize = this.selectFile.size;
          var kbsize: any = 0;
          kbsize = (bytesize / 1000).toFixed(2);
          let IsFileSizeExceed = false;
          if (kbsize > 1024) {
            if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
            else IsFileSizeExceed = false;
          }
          if (IsFileSizeExceed) {
            this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
            $("#PincodeUpload").val("");
            Helpers.setLoading(false);
            return;
          }
          //----------------------------------------------

          this.company = this.Company.Id;
          var fd = new FormData();
          var file = this.selectFile;
          if (fd.has("file")) {
            fd.set("file", this.selectFile);
          } else {
            fd.append("file", this.selectFile);
          }
          var body = fd;
          var headers = new Headers();
          let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieservice.get("user_access_token")));
          const token: string = "Bearer " + user_access_token;
          headers.append("Authorization", token);
          let options = new RequestOptions({ headers: headers });

          const apiUrl =
            environment.apiUrl +
            "/api/Company/ImportpincodeByCSV?CompanyId=" +
            this.company;
          const req1 = this.anghttp.post(apiUrl, body, options).subscribe(
            (res) => {
              Helpers.setLoading(false);
              this.toastr.success("Pincode Data Saved Successfully !", "Success");
              NetworkComponent.networkComponent.DataTablePincode(this.company);
              NetworkComponent.networkComponent.datatable.reload();
              $("#PincodeUpload").val("");
            },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("Error occurred while saving Pincode Data !", "error");
              $("#PincodeUpload").val("");
            }
          );
        }
      }, 300);

    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_pincode, #topbar_pincode").removeClass("active");
    }
  }

  //-----------------------Datatable Code------------------------------

  // ChangeCompany($event) {
  //     Helpers.setLoading(true);
  //     this.TenantId = JSON.parse(localStorage.getItem('ChnageCompnayId')).TenantId;
  //     NetworkComponent.networkComponent.Networkdatatable.destroy();
  //     this.DataTableNetwork();
  //     Helpers.setLoading(false);
  // }

  DataTableNetwork() {
    var _that = this;
    if (this.Networkdatatable) {
      this.Networkdatatable.reload();
    } else {
      this.Networkdatatable = (<any>$("#m_datatable_NetworkList")).mDatatable({
        data: {
          type: "remote",
          source: {
            read: {
              method: "POST",
              url: environment.apiUrl + "api/Network/GetNetworkData",
              params: {
                IsNetworkCompany: 1,
                TenantId: NetworkComponent.networkComponent.TenantId,
                //add kevin 27/10/2020
                isTranshporter: NetworkComponent.networkComponent.isTransporter,
                isCustomer: NetworkComponent.networkComponent.isCustomer,
                UserId: NetworkComponent.networkComponent.userId
                //end
              },
              map: function (raw) {
                var dataSet = raw;
                if (typeof raw.data !== "undefined") {
                  dataSet = raw.data;
                }
                return dataSet;
              },
            },
          },
          pageSize: 10,
          serverPaging: !0,
          serverFiltering: !0,
        },
        layout: {
          class: "m--margin-top-5",
          scroll: false,
          footer: false,
          smoothScroll: {
            scrollbarShown: true,
          },
        },
        sortable: !0,
        pagination: !0,
        toolbar: {
          items: {
            pagination: {
              pageSizeSelect: [10, 20, 30, 50, 100],
            },
          },
        },
        search: {
          onChange: true,
          input: $("#NetworkSearch"),
          delay: 400,
        },
        rows: {
          afterTemplate: function (row, data, index) {
            console.log(data);
            $(row)
              .find(".btnEditMaster")
              .click(function () {
                var Id = $(this).attr("Id");
                //added by vithujan 11-01-2023
                NetworkComponent.networkComponent.NetworkId = Id;
                //end
                NetworkComponent.networkComponent.checkCompanyType = '';
                var TransportModeType = data.TransportModeType;
                var arrayTransportModeType = TransportModeType.split(',');
                arrayTransportModeType.forEach(element => {
                  if (element.trim() == 'Transporter') {
                    NetworkComponent.networkComponent.checkCompanyType = 'Transporter';
                  }
                  if (element.trim() == 'Manufacturer') {
                    NetworkComponent.networkComponent.checkCompanyType = 'Manufacturer';
                  }
                });
                NetworkComponent.networkComponent.GetNetworkById(Id);
              });

            $(row)
              .find(".btnDelete")
              .click(function () {
                var Id = $(this).attr("Id");
                NetworkComponent.networkComponent.DeleteNetworkById(Id);
              });
          },
        },
        columns: [
          {
            field: "CompanyName",
            title: this.selectedLang == 'sp' ? "Nombre de la empresa" : "Company Name",
            filterable: !1,
            width: 200,
          },

          {
            field: "IsAuthorized",
            title: this.selectedLang == 'sp' ? "Autorizar" : "Authorize",
            filterable: !1,
            width: 100,
            template: function (t) {
              var res = "";
              if (t.IsAuthorized) {
                res = `<span class="m-badge m-badge--success m-badge--wide m-badge--roundedr">Authorized</span><br/>`;
              } else {
                res = `<span class="m-badge m-badge--danger m-badge--wide m-badge--roundedr">Unauthorized </span><br/>`;
              }
              return res;
            },
          },
          {
            field: "Isdisable",
            title: "Is Enabled",
            filterable: !1,
            width: 100,
            template: function (t) {
              var res = "";
              if (t.Isdisable) {
                res = `<span class="m-badge m-badge--danger m-badge--wide m-badge--roundedr">Disabled</span><br/>`;
              } else {
                res = `<span class="m-badge m-badge--success m-badge--wide m-badge--roundedr">Enabled</span><br/>`;
              }
              return res;
            },
          },
          {
            field: "ShipmentModeName",
            title: this.selectedLang == 'sp' ? "Tipo de red" : "Type of Network",
            filterable: !1,
            width: 200,
          },
          // {
          //   field: "TransportModeType",
          //   title: this.selectedLang == 'sp' ? "Tipo" : "Type",
          //   filterable: !1,
          //   width: 200,
          // },
          { field: "Email", title: this.selectedLang == 'sp' ? "Correo electrónico" : "Email Id", filterable: !1, width: 200 },
          { field: "Phone", title: this.selectedLang == 'sp' ? "Número de teléfono móvil" : "Mobile No", filterable: !1, width: 200 },
          {
            field: "Actions",
            width: 110,
            title: this.selectedLang == 'sp' ? "Acciones" : "Actions",
            sortable: !1,
            overflow: "visible",
            template: function (t) {
              var btn = "";
              if (
                NetworkComponent.networkComponent.commonService.CheckHasRight(
                  "VIEW",
                  "NETWORK_DETAILS"
                )
              ) {
                btn += `<a id="${t.Id}" class="btnEditMaster m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details"><i class="la la-edit"></i></a>`;
              }

              if (
                NetworkComponent.networkComponent.commonService.CheckHasRight(
                  "DELETE",
                  "NETWORK_DETAILS"
                )
              ) {
                btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete"><i class="la la-trash"></i></a>`;
              }
              return btn;
            },
          },
        ],
      });
    }

    // let i = this.datatable.getDataSourceQuery();
    // $("#m_form_status").on("change", function () {
    //   this.datatable.search($(this).val(), "IsDelete")
    // }).val(void 0 !== i.isActive ? i.isActive : "");
    // (<any>$("#m_form_status")).selectpicker();
  }
  GetNetworkById(Id) {

    this.ShowAttachment = true;
    this.isValidGST = true;
    if (this.commonService.CheckHasRight("EDIT", "NETWORK_DETAILS")) {
      $("#BtnAuthorizeNetwork").prop("disabled", false);
      $("#SaveBasicInfo").css("display", "inline-block");
      $("#SaveOtherDetails").css("display", "inline-block");
      $("#SaveAddress").css("display", "inline-block");
      $("#SaveContact").css("display", "inline-block");
      $("#btnSavebankDetailsForNetwork").css("display", "inline-block");
      $("#SaveRegistration").css("display", "inline-block");
      $("#SaveSocial").css("display", "inline-block");
      // add kevin 27-Dec-2021
      $("#SaveInfrastructure").css("display", "inline-block");
      // end
      $("#SaveRouteDetails").css("display", "inline-block");
      $("#btnUploadFile").css("display", "inline-block");
      $("#btnNewContact").css("display", "inline-block");
      $("#btnNewBankAccount").css("display", "inline-block");
      // $("#btnNewContract").css('display', 'inline-block')
      // $("#btnCopyContract").css('display', 'inline-block')
    } else {
      $("#SaveBasicInfo").css("display", "none");
      $("#SaveOtherDetails").css("display", "none");
      $("#SaveAddress").css("display", "none");
      $("#SaveContact").css("display", "none");
      $("#btnSavebankDetailsForNetwork").css("display", "none");
      $("#SaveRegistration").css("display", "none");
      $("#SaveSocial").css("display", "none");
      // add kevin 27-Dec-2021
      $("#SaveInfrastructure").css("display", "none");
      // end
      $("#SaveRouteDetails").css("display", "none");
      $("#btnUploadFile").css("display", "none");
      $("#btnNewContact").css("display", "none");
      $("#btnNewBankAccount").css("display", "none");
      // $("#btnNewContract").css('display', 'none')
      // $("#btnCopyContract").css('display', 'none')
    }
    this.EditD2D = Id;
    this.Networkdatatable.EditD2D = Id;
    this.GetTransportService();
    this.GetCustomerConversionFactorList(Id);

    this.EditName = "Edit";
    // this.CompanyId = Id;
    this.BillingAddress.CompanyId = Id;
    this.OfficialAddress.CompanyId = Id;
    this.Contacts.CompanyId = Id;
    this.registrationTypeList.CompanyId = Id;
    this.Social.CompanyId = Id;
    // add kevin 27-Dec-2021
    this.Infrastructure.CompanyId = Id;
    this.shipmentAllocationRule.companyId = Id;
    // end

    this._appService.GetById("Network", "GetNetworkDataById", Id).subscribe(
      (response) => {
        console.log(response);

        if (this.isOpenInOtherPage == false) {
          this.route.navigate(["/network", Id]);
        }
        if (response.OtherDetails != null) {
          this.OtherDetails = response.OtherDetails;

          this.ExemptionReasonText = "";
          this.TaxExemptionReason.forEach(element => {
            if (element.Id == this.OtherDetails.TaxExemptionId) {
              this.ExemptionReasonText = element.Label
            }
          });
          if (this.OtherDetails.TaxPreference == 'TaxExempt' && this.ExemptionReasonText == 'SEZ Customer' && this.SalesFlag == false) {
            $("#LUTBondStartDate").datepicker("setDate", new Date(this.OtherDetails.LUTBondStartDate));
            $("#LUTBondEndDate").datepicker("setDate", new Date(this.OtherDetails.LUTBondEndDate));
          }
          if (
            response.OtherDetails.TDSPreference != null &&
            response.OtherDetails.TDSPreference == "Deducted"
          ) {
            this.showTDSDropdown = true;
          }
          this.RefreshParentCompany();
        }
        this.CompanyFullName = response.Company.FullName;
        this.Company = response.Company;
        $('input:radio[name="checkbox_isFOV_ROV"]').prop("checked", false);
        $('input:radio[name="checkbox_isFOV_ROV"]').filter('[value="' + this.Company.IsFov_Rov + '"]').prop("checked", true);
        this.GetDeliveryPartnerSelect();
        //added by vithujan 17-01-2023
        NetworkComponent.networkComponent.GetDeliveryPartnerListByIds();
        //end


        // var Optionsse2_DeliveryPartner_net = "";
        // Optionsse2_DeliveryPartner_net += '<option value="' + this.Company.DeliveryPartner + '">' + this.Company.DeliveryPartnerName + "</option>";
        // $("#se2_DeliveryPartner_net").html(Optionsse2_DeliveryPartner_net);
        // $("#se2_DeliveryPartner_net").val(this.Company.DeliveryPartner).change();

        if (
          response.Company.FileName != null ||
          response.Company.FileName != undefined
        ) {
          var path =
            environment.apiUrl +
            "../../Document/Logos/" +
            response.Company.FileName +
            "." +
            response.Company.FileExtension;
          $("#ShowNetworkLogo").attr("src", path);
        }

        this.RefreshParentCompany();
        this.AccountData.Id = this.Company.AccountId;

        if (this.Company.AccountTypeName != null) {
          var Options = "";
          Options +=
            '<option value="' +
            this.Company.AccountTypeId +
            '">' +
            this.Company.AccountTypeName +
            "</option>";
          $("#NetworkAccountsType").html(Options);
          $("#NetworkAccountsType").val(this.Company.AccountTypeId).change();
        } else {
          var Options = "";
          Options += '<option value=""></option>';
          $("#NetworkAccountsType").html(Options);
          $("#NetworkAccountsType").val("").change();
        }
        if (this.Company.SalesPerson != null || this.Company.SalesPerson != undefined) {
          var Options
            =
            '<option value="' +
            this.Company.SalesPerson +
            '">' +
            this.Company.SalesPersonName +
            "</option>";
          $("#SalesPerson").html(Options);
          $("#SalesPerson").val(this.Company.SalesPerson).change();
        } else {
          var Options = "";
          Options += '<option value=""></option>';
          $("#SalesPerson").html(Options);
          $("#SalesPerson").val("").change();
        }
        if (response.ShipmentData.length > 0) {
          for (let index = 0; index < response.ShipmentData.length; index++) {
            setTimeout(() => {
              $("#CompanyTransport_" + response.ShipmentData[index].Id).prop(
                "checked",
                "checked"
              );
            }, 500);
          }
        }

        let Country = "";
        let State = "";
        let City = "";
        let CountryForBilling = "";
        let StateForBilling = "";
        let CityForBilling = "";

        if (response.AddressDetails.length > 0) {
          Country =
            '<option value="' +
            response.AddressDetails[0].Country +
            '">' +
            response.AddressDetails[0].Country +
            "</option>";
          $("#NCompanyCountry").html(Country);
          $("#NCompanyCountry")
            .val(response.AddressDetails[0].Country)
            .change();

          State =
            '<option value="' +
            response.AddressDetails[0].State +
            '">' +
            response.AddressDetails[0].State +
            "</option>";
          $("#NCompanyState").html(State);
          $("#NCompanyState").val(response.AddressDetails[0].State).change();

          City =
            '<option value="' +
            response.AddressDetails[0].City +
            '">' +
            response.AddressDetails[0].City +
            "</option>";
          $("#NCompanyCity").html(City);
          $("#NCompanyCity").val(response.AddressDetails[0].City).change();

          if (response.AddressDetails[0].IsDefaultPickup == true) {
            $("#IsDefaultPickup").prop("checked", true);
          } else {
            $("#IsDefaultPickup").prop("checked", false);
          }

          if (response.AddressDetails.length > 1) {
            if (
              response.AddressDetails[1].UnitNo ==
              response.AddressDetails[0].UnitNo &&
              response.AddressDetails[1].PostalCode ==
              response.AddressDetails[0].PostalCode &&
              response.AddressDetails[0].UnitNo != null &&
              response.AddressDetails[0].PostalCode
            ) {
              this.CompanyAddress.IsSame = true;

              CountryForBilling =
                '<option value="' +
                response.AddressDetails[1].Country +
                '">' +
                response.AddressDetails[1].Country +
                "</option>";
              $("#NCompanyCountryBilling").html(CountryForBilling);
              $("#NCompanyCountryBilling")
                .val(response.AddressDetails[1].Country)
                .change();

              StateForBilling =
                '<option value="' +
                response.AddressDetails[1].State +
                '">' +
                response.AddressDetails[1].State +
                "</option>";
              $("#NCompanyStateBilling").html(StateForBilling);
              $("#NCompanyStateBilling")
                .val(response.AddressDetails[1].State)
                .change();

              CityForBilling =
                '<option value="' +
                response.AddressDetails[1].City +
                '">' +
                response.AddressDetails[1].City +
                "</option>";
              $("#NCompanyCityBilling").html(CityForBilling);
              $("#NCompanyCityBilling")
                .val(response.AddressDetails[1].City)
                .change();
            } else {
              this.CompanyAddress.IsSame = false;
              $("#NCompanyCountryBilling").html(Country);
              var BllingState =
                '<option value="' +
                response.AddressDetails[1].State +
                '">' +
                response.AddressDetails[1].State +
                "</option>";
              $("#NCompanyStateBilling").html(BllingState);
              $("#NCompanyStateBilling")
                .val(response.AddressDetails[1].State)
                .change();
              var BllingCity =
                '<option value="' +
                response.AddressDetails[1].City +
                '">' +
                response.AddressDetails[1].City +
                "</option>";
              $("#NCompanyCityBilling").html(BllingCity);
              $("#NCompanyCityBilling")
                .val(response.AddressDetails[1].City)
                .change();

              this.GetBillingSelectData();
            }
            this.BillingAddress = response.AddressDetails[1];
          }
          this.OfficialAddress = response.AddressDetails[0];
        }
        if (response.CompanyRegistrations.length > 0) {
          this.registrationTypeList = response.CompanyRegistrations;
          this.registrationTypeList.forEach((element, index) => {
            element.Validity = element.ValidityDate;
          });
          this.RefreshvalidDate();
        } else {
          this.GetRegistrationData();
        }
        if (response.Allocationruleslist.length > 0) {
          this.shipmentAllocationRule = response.Allocationruleslist;

        } else {
          this.GetShipmentAllocatioRule();
        }
        if (response.CompanySocial != null) {
          this.Social = response.CompanySocial;
        }
        // add kevin 27-Dec-2021
        if (response.CompanyInfrastructures != null) {
          this.Infrastructure = response.CompanyInfrastructures;
        }
        this.Infrastructure.forEach(element => {
          if (element.Comment == '1 T') {
            this.CompanyInfrastructures.Fleet1t = element.Fleets;
          }
          if (element.Comment == '3.5 T') {
            this.CompanyInfrastructures.Fleet35t = element.Fleets;
          }
          if (element.Comment == '8 T') {
            this.CompanyInfrastructures.Fleet8t = element.Fleets;
          }
        });
        this.Infrastructure.forEach(element => {
          if (element.Comment == '1-20') {
            this.OneToTwenty = element.Fleets != 'true' ? false : true;
          }
          if (element.Comment == '21-40') {
            this.TwentyoneToForty = element.Fleets != 'true' ? false : true;
          }
          if (element.Comment == '41-60') {
            this.FortyoneToSixty = element.Fleets != 'true' ? false : true;
          }
          if (element.Comment == '+60') {
            this.AboveSixty = element.Fleets != 'true' ? false : true;
          }
        });
        // end
        this.myVar1 = true;
        this.myVar = false;
        if (this.isOpenWarehouse) {
          $(
            "#divtopbar_companyInfo,#topbar_companyInfo,#divtopbar_registration,#topbar_registration,#divtopbar_address,#divtopbar_contacts, #divtopbar_Social, #divtopbar_TranshipmentPoint,#divtopbar_pincode,#divtopbar_Contract,#divtopbar_NewContract,#topbar_address,#topbar_contacts,#topbar_registration,#topbar_social,#topbar_pincode,#topbar_TranshipmentPoints,#topbar_Contract,#topbar_NewContract,#divtopbar_Branch,#topbar_Branch,#topbar_Shipmentallocaitonrule,#divtopbar_Shipmentallocaitonrule"
          ).removeClass("active");
          $("#divtopbar_TranshipmentPoint,#topbar_TranshipmentPoints").addClass("active");
          this.onTranshipmentTap();
        }
      },
      (err) => {
        // this.toastr.error("An erro occured while Update Data", 'region');
      }
    );
    this.showNetworkDetails = !this.showNetworkDetails;
  }

  DeleteNetworkById(Id) {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: !0,
      confirmButtonText: "Yes, delete it!",
    }).then(function (e) {
      if (e.value == true) {
        Helpers.setLoading(true);
        NetworkComponent.networkComponent._appService
          .Delete("Network", "DeleteNetworkCompany", Id)
          .subscribe(
            (response) => {
              let resSTR = JSON.stringify(response);
              let resJSON = JSON.parse(resSTR);

              if (resJSON._body == 2) {
                Helpers.setLoading(false);
                NetworkComponent.networkComponent.toastr.warning(
                  "Can't delete becuase transactions are exists",
                  "warning"
                );
              } else if (resJSON._body == 3) {
                Helpers.setLoading(false);
                NetworkComponent.networkComponent.toastr.warning(
                  "Can't delete becuase transactions are exists in Bookings",
                  "warning"
                );
              }
              else if (resJSON._body == 0) {
                Helpers.setLoading(false);
                NetworkComponent.networkComponent.toastr.info(
                  "Transactions are exists for this Customer/Vendor, you are not allowed to delete.",
                  "Info"
                );
              }
              else if (resJSON._body == 8) {
                Helpers.setLoading(false);
                NetworkComponent.networkComponent.toastr.info(
                  "Transactions are exists for this Transporter, you are not allowed to delete.",
                  "Info"
                );
              }
              else {
                Helpers.setLoading(false);
                if (NetworkComponent.networkComponent.toggle == "list")
                  NetworkComponent.networkComponent.Networkdatatable.reload();
                if (NetworkComponent.networkComponent.toggle == "card")
                  NetworkComponent.networkComponent.GetNetworkCardData();
                NetworkComponent.networkComponent.toastr.success(
                  "Network Deleted Successfully !",
                  "Success"
                );
              }
            },
            (err) => {
              console.log("Error occured");
            }
          );
      }
    });
  }
  DataTablePincode(ID) {
    var _That = (this.PincodeDatatable = (<any>(
      $("#m_datatable_Pincode")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Company/GetPincodeList",
            params: {
              // custom parameters
              CompanyId: ID,
              TenantId: NetworkComponent.networkComponent.TenantId,
            },
            map: function (raw) {
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: true,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#SearchCity"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("Id");
              NetworkComponent.networkComponent._appService.GetById("Carrier", "GetCarrierById", Id).subscribe((response) => {
                NetworkComponent.networkComponent.TransshipmentPointModel = response;
                NetworkComponent.networkComponent.PincodeDatatable.reload();
                $("#newTransshipment").modal("show");
              },
                (err) => {
                  this.toastr.error("An erro occured while Update Data", "");
                }
              );
            });

          $(row)
            .find(".btnDelete")
            .click(function () {
              var Id = $(this).attr("Id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService
                    .Delete("Company", "DeletePincodeData", Id)
                    .subscribe(
                      (response) => {
                        NetworkComponent.networkComponent.PincodeDatatable.reload();
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
        },
      },
      columns: [
        {
          field: "Pincode",
          title: "Pincode",
          sortable: false,
          width: 80,
          textAlign: "left",
        },
        {
          field: "Area",
          title: "Area",
          filterable: !1,
          width: 150,
        },
        {
          field: "City",
          title: "City",
          filterable: !1,
          width: 150,
        },
        {
          field: "State",
          title: "State",
          filterable: !1,
          width: 150,
        },
        {
          field: "Country",
          title: "Country",
          filterable: !1,
          width: 150,
        },
        {
          field: "LocationZone",
          title: "Location Zone",
          filterable: !1,
          width: 150,
        },
        {
          field: "Metro",
          title: "Metro",
          filterable: !1,
          width: 100,
        },
        {
          field: "NonMetro1",
          title: "Non Metro 1",
          filterable: !1,
          width: 100,
        },
        {
          field: "NonMetro2",
          title: "Non Metro 2",
          filterable: !1,
          width: 100,
        },
        {
          field: "NonMetro3",
          title: "Non Metro 3",
          filterable: !1,
          width: 100,
        },
        {
          field: "NonMetro4",
          title: "Non Metro 4",
          filterable: !1,
          width: 100,
        },
        {
          field: "NonMetro5",
          title: "Non Metro 5",
          filterable: !1,
          width: 100,
        },
        {
          field: "ODA1",
          title: "ODA1",
          filterable: !1,
          width: 80,
        },
        {
          field: "ODA2",
          title: "ODA2",
          filterable: !1,
          width: 80,
        },
        {
          field: "ODA3",
          title: "ODA3",
          filterable: !1,
          width: 80,
        },
        {
          field: "ODA4",
          title: "ODA4",
          filterable: !1,
          width: 80,
        },
        {
          field: "ODA5",
          title: "ODA5",
          filterable: !1,
          width: 80,
        },
        {
          field: "GreenTax",
          title: "Green Tax",
          filterable: !1,
          width: 80,
        },
        {
          field: "pickupBranch",
          title: "Pickup Branch",
          filterable: !1,
          width: 150,
        },
        {
          field: "deliveryBranch",
          title: "Delivery Branch",
          filterable: !1,
          width: 150,
        },
        {
          field: "SmallAppliancesDeliveryBranch",
          title: "Small Appliances Delivery Branch",
          filterable: !1,
          width: 150,
        },
        {
          field: "isCodAllowed",
          title: "Cod Allowed",
          filterable: !1,
          width: 100,
        },
        {
          field: "isToPayAllowed",
          title: "ToPay Allowed",
          filterable: !1,
          width: 120,
        },
        {
          field: "isActive",
          title: "Active",
          filterable: !1,
          width: 80,
        },
        {
          field: "LocationType",
          title: "Location Type",
          filterable: !1,
          width: 150,
        },
        {
          field: "ReportingBranch",
          title: "Reporting Branch",
          filterable: !1,
          width: 150,
        },
        {
          field: "isPickupActive",
          title: "Pickup Active",
          filterable: !1,
          width: 100,
        },
        {
          field: "isDeliveryActive",
          title: "Delivery Active",
          filterable: !1,
          width: 120,
        },
        {
          field: "NEWINDIA1",
          title: "NEWINDIA1",
          filterable: !1,
          width: 80,
        },
        {
          field: "NEWINDIA2",
          title: "NEWINDIA2",
          filterable: !1,
          width: 80,
        },
        {
          field: "NEWINDIA3",
          title: "NEWINDIA3",
          filterable: !1,
          width: 80,
        },
        {
          field: "Actions",
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          class: "TEST",
          textAlign: "left",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                        <i class="la la-trash"></i>
                                        </a>`;
            }

            return btn;
          },
        },
      ],
    }));

    $("#SearchTrnashipment").on("change", function () {
      _That.search($(this).val(), "SearchTranshipment");
    });

    $("#SearchCity").on("change", function () {
      _That.search($(this).val(), "SearchCity");
    });
  }

  DataTableCarrier() {
    if (this.carrierDatatable) {
      this.carrierDatatable.reload();
    } else {
      this.carrierDatatable = (<any>$("#m_datatable_CarrierList")).mDatatable({
        data: {
          type: "remote",
          source: {
            read: {
              method: "POST",
              url: environment.apiUrl + "api/Carrier/GetCarrierData",
              params: {
                TenantId: NetworkComponent.networkComponent.TenantId,
              },
              map: function (raw) {
                var dataSet = raw;
                if (typeof raw.data !== "undefined") {
                  dataSet = raw.data;
                }
                return dataSet;
              },
            },
          },
          pageSize: 10,
          serverPaging: !0,
          serverFiltering: !0,
        },
        layout: {
          class: "m--margin-top-5",
          scroll: true,
          footer: !1,
          smoothScroll: {
            scrollbarShown: true,
          },
        },
        sortable: !0,
        pagination: !0,
        toolbar: {
          items: {
            pagination: {
              pageSizeSelect: [10, 20, 30, 50, 100],
            },
          },
        },
        search: {
          onEnter: true,
          //input: $('#RegionNameSearch'),
          delay: 400,
        },
        rows: {
          afterTemplate: function (row, data, index) {
            $(row)
              .find(".btnEdit")
              .click(function () {
                NetworkComponent.networkComponent.ClearWareHoueseValidation();
                var Id = $(this).attr("Id");
                NetworkComponent.networkComponent._appService
                  .GetById("Carrier", "GetCarrierById", Id)
                  .subscribe(
                    (response) => {
                      NetworkComponent.networkComponent.TransshipmentPointModel = response;
                      NetworkComponent.networkComponent.carrierDatatable.reload();
                      $("#newTransshipment").modal("show");
                    },
                    (err) => {
                      this.toastr.error(
                        "An erro occured while Update Data",
                        ""
                      );
                    }
                  );
              });

            $(row)
              .find(".btnDelete")
              .click(function () {
                var Id = $(this).attr("Id");
                swal({
                  title: "Are you sure?",
                  text: "You won't be able to revert this!",
                  type: "warning",
                  showCancelButton: !0,
                  confirmButtonText: "Yes, delete it!",
                }).then(function (e) {
                  if (e.value == true) {
                    NetworkComponent.networkComponent._appService
                      .Delete("Carrier", "DeleteCarrierData", Id)
                      .subscribe(
                        (response) => {
                          NetworkComponent.networkComponent.carrierDatatable.reload();
                          this.ClearWareHoueseValidation();
                        },
                        (err) => {
                          console.log("Error occured");
                        }
                      );
                  }
                });
              });
          },
        },
        columns: [
          { field: "Name", title: "Name", filterable: !1, width: 200 },
          { field: "Town", title: "City", filterable: !1, width: 200 },
          { field: "RegionState", title: "State", filterable: !1, width: 200 },
          {
            field: "ContactPerson",
            title: "Contact",
            filterable: !1,
            width: 200,
          },
          {
            field: "MobileNumber",
            title: "Mobile",
            filterable: !1,
            width: 200,
          },
          {
            field: "Actions",
            width: 110,
            title: "Actions",
            sortable: !1,
            overflow: "visible",
            template: function (t) {
              var btn = "";
              btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details"><i class="la la-edit"></i>\t\t\t\t\t\t</a>`;
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete"><i class="la la-trash"></i></a>`;
              return btn;
            },
          },
        ],
      });
    }
  }

  GetContactsList(ID) {
    this.ContactsDatatable = (<any>$("#m_datatable_Contacts")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Company/GetContactList",
            params: {
              // custom parameters
              CompanyId: ID,
              TenantId: NetworkComponent.networkComponent.TenantId,
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }

              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#ContactName"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("id");
              NetworkComponent.networkComponent._appService
                .GetById("Company", "GetContact", Id)
                .subscribe(
                  (response) => {
                    NetworkComponent.networkComponent.Contacts = response;
                    NetworkComponent.networkComponent.Contacts.EscalationLevel =
                      response.EscalationLevel;
                    NetworkComponent.networkComponent.ContactsDatatable.reload();
                    $("#newContact").modal("show");
                  },
                  (err) => {
                    console.log("Error occured");
                  }
                );
            });

          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService
                    .Delete("Company", "DeleteContact", Id)
                    .subscribe(
                      (response) => {
                        swal("Contact deleted successfully !", "", "success");
                        NetworkComponent.networkComponent.datatable.reload();
                        NetworkComponent.networkComponent.ContactsDatatable.reload();
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
        },
      },

      columns: [
        {
          field: "ContactFullName",
          title: "Contact Name",
          textAlign: "center",
        },
        // { field: "ContactFullName", title: "Contact Name", filterable: !1, sortable: 0, width: 200 },
        { field: "PhoneNo", title: "Phone", filterable: !1 },
        { field: "Email", title: "Email", filterable: !1 },
        { field: "Designation", title: "Designation", filterable: !1 },
        {
          field: "Actions",
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "VIEW",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}"class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details"><i class="la la-edit"></i></a>`;
            }
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete"><i class="la la-trash"></i>`;
            }
            return btn;
          },
        },
      ],
    });
  }

  GetProductDataList(ID) {
    var _That = (this.ProductDataTable = (<any>(
      $("#m_datatable_Product")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Network/cprd_GetProductDataList",
            params: {
              // custom parameters
              CompanyId: ID
            },
            map: function (raw) {
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: true,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#in_cprd_searchProduct"),
        delay: 100,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnDelete")
            .click(function () {
              var Id = $(this).attr("Id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService.GetByTwoId("Network", "cprd_DeleteProductData", Id, NetworkComponent.networkComponent.userId).subscribe((response) => {
                    NetworkComponent.networkComponent.ProductDataTable.reload();
                  },
                    (err) => {
                      console.log("Error occured");
                    }
                  );
                }
              });
            });
        },
      },
      columns: [
        {
          field: "ProductCode",
          title: "Product Code",
          sortable: false,
          width: 100,
          textAlign: "left",
        },
        {
          field: "ProductName",
          title: "Product Name",
          sortable: false,
          width: 150,
        },
        {
          field: "Rate",
          title: "Rate",
          sortable: false,
          width: 80,
        },
        {
          field: "FromDate",
          title: "From Date",
          sortable: false,
          width: 80,
        },
        {
          field: "ToDate",
          title: "To Date",
          sortable: false,
          width: 80,
        },
        {
          field: "Actions",
          title: "Actions",
          sortable: false,
          overflow: "visible",
          textAlign: "left",
          template: function (t) {
            var btn = "";
            btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                        <i class="la la-trash"></i>
                                        </a>`;
            return btn;
          },
        },
      ],
    }));
  }

  GetTranshipmentPonitList(ID) {
    this.TranshipmentDatatable = (<any>(
      $("#m_datatable_Transhipment")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Carrier/GetTranshipmentData",
            params: {
              // custom parameters
              CompanyId: ID,
              TenantId: NetworkComponent.networkComponent.TenantId,
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#CarrierNameSearch"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              NetworkComponent.networkComponent.ClearTransipPointData();
              var Id = $(this).attr("id");
              NetworkComponent.networkComponent._appService.GetById("Carrier", "GetCarrierById", Id).subscribe((response) => {
                NetworkComponent.networkComponent.TransshipmentPointModel = response;
                NetworkComponent.networkComponent.Contacts.EscalationLevel = response.EscalationLevel;
                NetworkComponent.networkComponent.RefreshSelect2();
                if (response.OwnershipId != null) {
                  var Options =
                    '<option value="' + response.OwnershipId + '">' + response.OwnershipName + "</option>";
                  $("#SelectTranshipOwnership").html(Options);
                  $("#SelectTranshipOwnership").val(response.OwnershipId).change();
                }

                if (response.PickupBranch != null) {
                  var PickupBranchOptions =
                    '<option value="' + response.PickupBranch + '">' + response.PickupBranchName + "</option>";
                  $("#se2_ctpPickupBranch").html(PickupBranchOptions);
                  $("#se2_ctpPickupBranch").val(response.PickupBranch).change();
                }
                if (response.DeliveryBranch != null) {
                  var DeliveryBranchOptions =
                    '<option value="' + response.DeliveryBranch + '">' + response.DeliveryBranchName + "</option>";
                  $("#se2_ctpDeliveryBranch").html(DeliveryBranchOptions);
                  $("#se2_ctpDeliveryBranch").val(response.DeliveryBranch).change();
                }
                NetworkComponent.networkComponent.RefreshTranshipmentDropdown();

                $("#in_DeliveryFromTimeWindow").val(response.DeliveryFromTimeWindow);
                $("#in_DeliveryToTimeWindow").val(response.DeliveryToTimeWindow);
                setTimeout(() => {
                  NetworkComponent.networkComponent.RefreshvalidTimePicker();
                  setTimeout(() => {
                    var optDeliveryTimeWindow = "";
                    var optDeliveryTimeWindowVal = $("#in_DeliveryFromTimeWindow").val() + " To " + $("#in_DeliveryToTimeWindow").val();
                    if (optDeliveryTimeWindowVal != '12:00 AM To 12:00 AM') {
                      optDeliveryTimeWindow += '<option value="' + optDeliveryTimeWindowVal + '">' + optDeliveryTimeWindowVal + "</option>";
                      $("#se2_DeliveryTimeWindow").html(optDeliveryTimeWindow);
                      $("#se2_DeliveryTimeWindow").val(optDeliveryTimeWindowVal).change();
                    }
                  }, 100);
                }, 100);
                $("#newTransshipment").modal("show");
              },
                (err) => {
                  console.log("Error occured");
                }
              );
            });

          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService
                    .Delete("Network", "DeleteTranshipmentPoint", Id)
                    .subscribe(
                      (response) => {
                        swal("Contact deleted successfully !", "", "success");
                        NetworkComponent.networkComponent.TranshipmentDatatable.reload();
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
          $("#m_datatable_Transhipment thead span").each(function (i) {
            if (i == 0) {
            }
            $(this).css("width", "90px");
            $('#m_datatable_Transhipment tbody span:eq("' + i + '")').css(
              "width",
              "90px"
            );
          });
        },
      },
      columns: [
        { field: "Code", title: "Code", textAlign: "left", width: 100 },
        { field: "Name", title: "Name", textAlign: "left", width: 100 },
        {
          field: "Town",
          title: "City",
          textAlign: "left",
          filterable: !1,
          width: 100,
        },
        {
          field: "RegionState",
          title: "State",
          textAlign: "left",
          filterable: !1,
          width: 100,
        },
        {
          field: "ContactPerson",
          title: "Contact",
          textAlign: "left",
          filterable: !1,
          width: 100,
        },
        {
          field: "MobileNumber",
          title: "Mobile",
          textAlign: "left",
          filterable: !1,
          width: 100,
        },
        {
          field: "Actions",
          width: 110,
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          textAlign: "left",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "VIEW",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details">
                                        <i class="la la-edit"></i>
                                        </a>`;
            }
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                        <i class="la la-trash"></i>
                                        </a>`;
            }
            return btn;
          },
        },
      ],
    });
  }

  GetContractList(ID) {
    this.ContractDatatable = (<any>$("#m_datatable_Contract")).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Carrier/NewCarrierContractGet",
            params: {
              // custom parameters
              CompanyId: ID,
              TenantId: NetworkComponent.networkComponent.TenantId,
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: true,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#ContactName"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("id");
              //this.carrierContractMasterId = Id;
              if (
                NetworkComponent.networkComponent.commonService.CheckHasRight(
                  "EDIT",
                  "CONTRACT_DETAILS"
                )
              ) {
                $("#SaveRouteDetails").css("display", "inline-block");
                $("#BtnUploadRate").css("display", "inline-block");
              } else {
                $("#SaveRouteDetails").css("display", "none");
                $("#BtnUploadRate").css("display", "none");
              }

              NetworkComponent.networkComponent._appService
                .GetById("Carrier", "GetNewContractById", Id)
                .subscribe(
                  (response) => {
                    NetworkComponent.networkComponent.ContractsList = true;
                    NetworkComponent.networkComponent.ContractScreen = false;
                    NetworkComponent.networkComponent.OnContract = false;
                    NetworkComponent.networkComponent.CarrierContractMaster = response;
                    NetworkComponent.networkComponent.carrierContractMasterId = Id;
                    if (
                      NetworkComponent.networkComponent.EditContractDatatable !=
                      undefined
                    ) {
                      NetworkComponent.networkComponent.EditContractDatatable.destroy();
                    }

                    NetworkComponent.networkComponent.GetEditCarrierContractGetList(
                      Id
                    );

                    NetworkComponent.networkComponent.CarrierContractMaster.StartDate = NetworkComponent.networkComponent.datepipe.transform(
                      response.StartDate,
                      "dd/MM/yyyy"
                    );
                    $("#StartDate").datepicker("setDate", response.StartDate);
                    NetworkComponent.networkComponent.CarrierContractMaster.EndDate = NetworkComponent.networkComponent.datepipe.transform(
                      response.EndDate,
                      "dd/MM/yyyy"
                    );
                    $("#EndDate").datepicker("setDate", response.EndDate);
                    NetworkComponent.networkComponent.CarrierContractMaster.ApprovedOn = NetworkComponent.networkComponent.datepipe.transform(
                      response.ApprovedOn,
                      "dd/MM/yyyy"
                    );
                    $("#ApprovedOn").datepicker("setDate", response.ApprovedOn);
                    NetworkComponent.networkComponent.CarrierContractMaster.LastUpdatedOn = NetworkComponent.networkComponent.datepipe.transform(
                      response.LastUpdatedOn,
                      "dd/MM/yyyy"
                    );
                    $("#LastUpdatedOn").datepicker(
                      "setDate",
                      response.LastUpdatedOn
                    );
                    NetworkComponent.networkComponent.CarrierContractMaster.LastPriceRevisedOn = NetworkComponent.networkComponent.datepipe.transform(
                      response.LastPriceRevisedOn,
                      "dd/MM/yyyy"
                    );
                    $("#LastPriceRevisedOn").datepicker(
                      "setDate",
                      response.LastPriceRevisedOn
                    );

                    NetworkComponent.networkComponent.RefreshParentCompany();
                  },
                  (err) => {
                    console.log(err);
                    console.log("Error occured");
                  }
                );
            });

          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService
                    .Delete("Carrier", "DeleteCarrierContractMasterData", Id)
                    .subscribe(
                      (response) => {
                        swal("Contact deleted successfully !", "", "success");
                        NetworkComponent.networkComponent.ContractDatatable.reload(
                          ID
                        );
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
        },
      },
      columns: [
        {
          field: "ContractNo",
          title: "Contract No#",
          textAlign: "center",
          width: 100,
        },
        {
          field: "StartDate",
          title: "Start Date",
          textAlign: "center",
          width: 200,
        },
        { field: "EndDate", title: "End Date", filterable: !1, width: 100 },
        {
          field: "ContractStatus",
          title: "Contract Status",
          filterable: !1,
          width: 150,
        },
        {
          field: "Approvedby",
          title: "Approved By",
          filterable: !1,
          width: 100,
        },
        {
          field: "RevisionNo",
          title: "Revision No#",
          filterable: !1,
          width: 100,
        },
        {
          field: "LastUpdatedOn",
          title: "Last Updated On",
          filterable: !1,
          width: 100,
        },
        {
          field: "CreatedDate",
          title: "Created Date",
          filterable: !1,
          width: 100,
        },
        {
          field: "Actions",
          width: 110,
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "VIEW",
                "CONTRACT_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details">
                                        <i class="la la-edit"></i>
                                        </a>`;
            }
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE",
                "CONTRACT_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                                        <i class="la la-trash"></i>
                                        </a>`;
            }
            return btn;
          },
        },
      ],
    });
  }

  //------------------------clear Data ------------------------------------------

  NewTranshipPoint() {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      this.ClearTransipPointData();
      $("#newTransshipment").modal("show");
    } else {
      $("#newTransshipment").modal("hide");
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_TranshipmentPoint, #topbar_TranshipmentPoints").removeClass(
        "active"
      );
    }
  }

  ClearTransipPointData() {
    this.TransshipmentPointModel = {};
    this.RefreshSelect2();
    this.RefreshTranshipmentDropdown();
    if ($("#se2_DeliveryTimeWindow").select2()) {
      $("#se2_DeliveryTimeWindow").val("");
      $("#se2_DeliveryTimeWindow").select2("destroy");
    }
    this.GetDeliveryTimeWindowSelectData();
  }

  NewContect() {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      this.Contacts = {};
      this.ClearValidateContact();
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_contacts, #topbar_contacts").removeClass("active");
    }
  }

  OnNewNetworkClick(isUlip: any) {
    //this.GetShipmentAllocatioRule();
    this.myVar1 = true;
    this.myVar = false;
    this.ShowAttachment = false;
    this.isValidGST = true;
    this.NewNetwork = true;
    this.EditName = "New Network";
    $('input:radio[name="checkbox_isFOV_ROV"]').prop("checked", false);
    $("#BtnAuthorizeNetwork").prop("disabled", true);
    this.GetTransportService();
    //added by vithujan 30-12-2022
    this.GetParentCompanyCountry();
    // end
    this.GetDeliveryPartnerSelect();
    $("#ShowNetworkLogo").attr(
      "src",
      "./assets/app/media/img/logos/InsertLogo.png"
    );
    if (
      NetworkComponent.networkComponent.commonService.CheckHasRight(
        "ADD",
        "NETWORK_DETAILS"
      )
    ) {
      $("#SaveBasicInfo").css("display", "inline-block");
      $("#SaveOtherDetails").css("display", "inline-block");
      $("#SaveAddress").css("display", "inline-block");
      $("#SaveContact").css("display", "inline-block");
      $("#btnSavebankDetailsForNetwork").css("display", "inline-block");
      $("#SaveRegistration").css("display", "inline-block");
      $("#SaveSocial").css("display", "inline-block");
      $("#SaveRouteDetails").css("display", "inline-block");
      $("#btnUploadFile").css("display", "inline-block");
      $("#btnNewContact").css("display", "inline-block");
      $("#btnNewBankAccount").css("display", "inline-block");
      // $("#btnNewContract").css('display', 'inline-block')
      // $("#btnCopyContract").css('display', 'inline-block')
    } else {
      $("#SaveBasicInfo").css("display", "none");
      $("#SaveOtherDetails").css("display", "none");
      $("#SaveAddress").css("display", "none");
      $("#SaveContact").css("display", "none");
      $("#btnSavebankDetailsForNetwork").css("display", "none");
      $("#SaveRegistration").css("display", "none");
      $("#SaveSocial").css("display", "none");
      $("#SaveRouteDetails").css("display", "none");
      $("#btnUploadFile").css("display", "none");
      $("#btnNewContact").css("display", "none");
      $("#btnNewBankAccount").css("display", "none");
      // $("#btnNewContract").css('display', 'none')
      // $("#btnCopyContract").css('display', 'none')
    }

    //added by vithujan 22-07-2023
    $("#se2_Accounts").val("");
    $("#se2_Accounts").text("");

    //add by maaria on 30-11-2023
    // this.DriverDetailChild.ClearUlipData();
    // this.LicenseChild.ClearUlipData();
    // this.RegistrationChild.ClearUlipData();

    if (isUlip == "true") {
      // this.DriverDetailChild.BindUlipDetail(this.sarathiData);
      // this.LicenseChild.BindUlipLicense(this.sarathiData);
      // this.RegistrationChild.BindUlipRegistration(this.sarathiData);
    }
    //end
    $("#InvoiceDue").val("0");
    $("#CreditLimit").val("0");
  }

  OnNewContract() {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      this.ContractsList = true;
      this.ContractScreen = false;
      NetworkComponent.networkComponent.OnContract = false;
      this.CarrierContractMaster = {};
      $("#StartDate").val("");
      $("#EndDate").val("");
      $("#ApprovedOn").val("");
      $("#LastUpdatedOn").val("");

      this.GetValueType();
      if (this.EditContractDatatable) {
        this.EditContractDatatable.destroy();
      }
      this.GetEditCarrierContractGetList(this.Company.Id);

      if (this.commonService.CheckHasRight("ADD", "CONTRACT_DETAILS")) {
        $("#SaveRouteDetails").css("display", "inline-block");
        $("#BtnUploadRate").css("display", "inline-block");
      } else {
        $("#SaveRouteDetails").css("display", "none");
        $("#BtnUploadRate").css("display", "none");
      }

      if (!this.commonService.CheckHasRight("AUTHORIZE", "CONTRACT_DETAILS")) {
        this.ContractStatus = this.ContractStatus.filter(
          (status) => status.StatusName !== "Authorized"
        );
      }
    } else {
      this.toastr.error("Please Fill Basic Information !", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_Contract, #topbar_Contract").removeClass("active");
    }
  }

  //----------------------------next btn -------------------------------------------
  NextBtnClick(ScreenName) {
    $(
      `#divtopbar_companyInfo,#topbar_companyInfo
      ,#divtopbar_OtherDetails,#topbar_OtherDetails
      ,#divtopbar_address, #topbar_address
      ,#divtopbar_contacts,#topbar_contacts
      ,#divtopbar_bankaccounts,#topbar_bankaccounts
      ,#divtopbar_registration,#topbar_registration
      ,#divtopbar_Social,#topbar_social
      ,#divtopbar_TranshipmentPoint,#topbar_TranshipmentPoints
      ,#divtopbar_pincode,#topbar_pincode
      ,#divtopbar_Contract,#topbar_Contract
      ,#divtopbar_Product,#topbar_Product
      ,#divtopbar_Branch,#topbar_Branch
      ,#divtopbar_SubCompany,#topbar_SubCompany
      ,#divtopbar_Accounts,#topbar_Accounts
      ,#divtopbar_Shipmentallocaitonrule,#topbar_Shipmentallocaitonrule
      ,#divtopbar_Infrastructure,#topbar_Infrastructure
      `
    ).removeClass("active");
    if (ScreenName == "TranshipmentPoint") {
      $("#divtopbar_pincode,#topbar_pincode").addClass("active");
      NetworkComponent.networkComponent.DataTablePincode(this.EditD2D);
    }
    if (ScreenName == "Pincode") {
      $("#divtopbar_Contract,#topbar_Contract").addClass("active");
      this.onContractMasterTap();
    }
    if (ScreenName == "BankAccount") {
      $("#divtopbar_bankaccounts,#topbar_bankaccounts").addClass("active");
      NetworkComponent.networkComponent.GetBankAccountList(this.EditD2D);
    }
    if (ScreenName == "Registration") {
      $("#divtopbar_registration,#topbar_registration").addClass("active");
    }
    if (ScreenName == "Contract") {
      $("#divtopbar_Product,#topbar_Product").addClass("active");
      this.onProductTap();
    }
    if (ScreenName == "Product") {
      $("#divtopbar_Branch,#topbar_Branch").addClass("active");
      this.onCompanyBranchTap();
    }
    if (ScreenName == "CompanyBranch") {
      $("#divtopbar_SubCompany,#topbar_SubCompany").addClass("active");
      this.onCompanySubCompanyTap();
    }
    if (ScreenName == "CompanySubCompany") {
      $("#topbar_Accounts,#divtopbar_Accounts").addClass("active");
    }
    //added by vithujan 21-07-2023
    if (ScreenName == "Accounts") {
      $("#divtopbar_Shipmentallocaitonrule,#topbar_Shipmentallocaitonrule").addClass("active");
      this.UpdateAccountId();
    }
    //added by rahul
    if (ScreenName == "AllocationRule") {
      $("#topbar_companyInfo,#divtopbar_companyInfo").addClass("active");
      this.SaveShipmentallocaitonrule();
    }
    //end
  }
  //----------------------------Cancel btn -------------------------------------------
  ContractMasterCancelBtn() {
    this.ContractsList = false;
    this.ContractScreen = true;

    NetworkComponent.networkComponent.ContractDatatable.destroy();
    NetworkComponent.networkComponent.GetContractList(this.Company.Id);
    // NetworkComponent.networkComponent.ContractDatatable.reload();
  }
  //----------------------------Validation btn -------------------------------------------

  ValidateCarrierContractMaster() {
    var flag = true;
    if (
      !NetworkComponent.networkComponent.commonService.ValidateRequiredField2(
        $("#ContractStatus"),
        $("#FieldSetType"),
        "Please Select Option",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#ContractNo"),
        "Please Enter Contract No",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#StartDate"),
        "Please Enter Start Date",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#EndDate"),
        "Please Enter End Date",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#Approvedby"),
        "Please Enter Approved By",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#ApprovedOn"),
        "Please Enter Approved On",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#LastUpdatedOn"),
        "Please Enter Last Updated Date Of Contract",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#RevisionNo"),
        "Please Enter Revision No",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    return flag;
  }

  ClearValidations() {
    NetworkComponent.networkComponent.commonService.ClearMessage(
      $("#FieldSetType")
    );
  }

  DownloadTemplate(RatesName) {
    // added by vithujan 24 - 09 - 2022(rel = "noopener noreferrer")
    if (RatesName == "FTL") {
      window.open(
        environment.apiUrl +
        "Uploads/Rates/RateUpload.csv?AppVersion=" +
        this.SystemVersion,
        "_blank", "noopener noreferrer"
      );
    } else if (RatesName == "LTL") {
      window.open(
        environment.apiUrl +
        "Uploads/Rates/RateLTL.csv?AppVersion=" +
        this.SystemVersion,
        "_blank", "noopener noreferrer"
      );
    } else if (RatesName == "Courier") {
      window.open(
        environment.apiUrl +
        "Uploads/Rates/Courier_Rate.csv?AppVersion=" +
        this.SystemVersion,
        "_blank", "noopener noreferrer"
      );
    } else if (RatesName == "Truck") {
      window.open(
        environment.apiUrl +
        "Uploads/Rates/TruckRatesTemplate.csv?AppVersion=" +
        this.SystemVersion,
        "_blank", "noopener noreferrer"
      );
    }
  }

  //-------------------------------Rate-------------------------------------------

  GetEditCarrierContractGetList(Id) {
    this.EditContractDatatable = (<any>(
      $("#m_datatable_Contract_Edit")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Carrier/EditCarrierContractGet",
            params: {
              Id, //CarrierContractMasterId
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#ContactName"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("id");
              if (
                NetworkComponent.networkComponent.commonService.CheckHasRight(
                  "EDIT",
                  "CONTRACT_DETAILS"
                )
              ) {
                $("#BtbSaveRate").css("display", "inline-block");
              } else {
                $("#BtbSaveRate").css("display", "none");
              }
              NetworkComponent.networkComponent._appService
                .GetById("Carrier", "EditGetContractById", Id)
                .subscribe(
                  (response) => {
                    NetworkComponent.networkComponent.EditContract.Id = Id;
                    NetworkComponent.networkComponent.EditContract = response;
                    console.log(NetworkComponent.networkComponent.EditContract, 'NetworkComponent.networkComponent.EditContract')
                    NetworkComponent.networkComponent.EditContractDatatable.reload();
                    $("#EditContract").modal("show");
                  },
                  (err) => {
                    console.log("Error occured");
                  }
                );
            });

          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService
                    .Delete("Rates", "DeleteRates", Id)
                    .subscribe(
                      (response) => {
                        swal("Rate deleted successfully !", "", "success");
                        NetworkComponent.networkComponent.EditContractDatatable.reload();
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
        },
      },

      columns: [
        {
          field: "ChargeCode",
          title: "Charge Code",
          textAlign: "left",
          filterable: !1,
          width: 200,
        },
        {
          field: "FromCity",
          title: "From",
          textAlign: "center",
          filterable: !1,
          width: 100,
        },
        {
          field: "ToCity",
          title: "To",
          textAlign: "center",
          filterable: !1,
          width: 100,
        },
        {
          field: "TransportService",
          title: "Transport Service",
          filterable: !1,
          width: 100,
        },
        { field: "Km", title: "Km", filterable: !1, width: 50 },
        { field: "Lead Time", title: "LeadTime", filterable: !1, width: 80 },
        { field: "ApplyBy", title: "ApplyBy", filterable: !1, width: 100 },
        {
          field: "VehicleType",
          title: "ApplybyUnit",
          filterable: !1,
          width: 100,
        },
        { field: "Currency", title: "Currency", filterable: !1, width: 70 },
        { field: "Unit", title: "Unit", filterable: !1, width: 50 },
        { field: "UnitRate", title: "Unit Rate", filterable: !1, width: 100 },
        { field: "Min", title: "Min", filterable: !1, width: 30 },
        { field: "Max", title: "Max", filterable: !1, width: 30 },
        {
          field: "ChargesPer",
          title: "Charges Per",
          filterable: !1,
          width: 90,
        },
        {
          field: "LocationCity",
          title: "Location City",
          filterable: !1,
          width: 200,
        },
        {
          field: "Actions",
          width: 110,
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "VIEW",
                "CONTRACT_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details"><i class="la la-edit"></i></a>`;
            }
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE",
                "CONTRACT_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete"><i class="la la-trash"></i></a>`;
            }
            return btn;
          },
        },
      ],
    });

    $("#ChargeCode").on("change", function () {
      NetworkComponent.networkComponent.EditContractDatatable.search(
        $(this).val(),
        "SearchChargeCode"
      );
    });

    $("#FromSearch").on("change", function () {
      NetworkComponent.networkComponent.EditContractDatatable.search(
        $(this).val(),
        "SearchFrom"
      );
    });

    $("#ToSearch").on("change", function () {
      NetworkComponent.networkComponent.EditContractDatatable.search(
        $(this).val(),
        "SearchTo"
      );
    });

    $("#ApplyBySearch").on("change", function () {
      NetworkComponent.networkComponent.EditContractDatatable.search(
        $(this).val(),
        "SearchApplyBy"
      );
    });

    $("#ApplyByUnitSearch").on("change", function () {
      NetworkComponent.networkComponent.EditContractDatatable.search(
        $(this).val(),
        "SearchApplyByUnit"
      );
    });
  }

  DownloadContractedRates() {
    Helpers.setLoading(true);
    var RateList: any = [];
    RateList = $("#m_datatable_Contract_Edit").mDatatable().dataSet;

    if (RateList.length > 0) {
      let Id = $("#m_datatable_Contract_Edit").mDatatable().dataSet[0]
        .CarrierContractMasterId;
      this._appService
        .GetById("Carrier", "ExportData", Id)
        .subscribe((response) => {
          this.DownloadFile(response);
          Helpers.setLoading(false);
        });
    } else {
      Helpers.setLoading(false);
      this.toastr.error("Data not Avaliable");
    }
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileRateContract").attr("href", url);
    $("#DownLoadFileRateContract").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById(
      "DownLoadFileRateContract"
    ) as HTMLElement;
    element.attributes;
    element.click();
  }

  SaveEditContract() {
    this._appService
      .Post("Carrier", "SaveCarrierContratEditData", this.EditContract)
      .subscribe(
        (response) => {
          NetworkComponent.networkComponent.EditContractDatatable.reload();
          $("#EditContract").modal("hide");
        },
        (err) => {
          console.log("Error occured");
        }
      );
  }

  selectFileCarrier: any;

  UploadCarrierExcel(event, carrierContractMasterId) {

    Helpers.setLoading(true);
    this.selectFileCarrier = event.target.files[0];

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    var fileReader = new FileReader();
    var isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
      var header = "";

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (header.toUpperCase() != '43686172') {
        NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.CSVOnly"), 'Error');
        $("#btnUploadFile").val("");
        isValidFileType = false;
        Helpers.setLoading(false);
        return false;
      }
    };
    fileReader.readAsArrayBuffer(this.selectFileCarrier);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;

        var filesName1 = this.selectFileCarrier.name;
        console.log(format);
        console.log(filesName1);
        if (!format.test(filesName1)) {
          this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
          $("#btnUploadFile").val("");
          Helpers.setLoading(false);
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        var meme_type = this.selectFileCarrier.type;
        if ((meme_type.toLowerCase() != "text/csv")) {
          this.toastr.error(this.translate.instant("SETTING.CSVOnly"), 'Error');
          $("#btnUploadFile").val("");
          Helpers.setLoading(false);
          return;
        }

        //--------------Size Validation----------------
        var bytesize = this.selectFileCarrier.size;
        var kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
          $("#btnUploadFile").val("");
          Helpers.setLoading(false);
          return;
        }
        //----------------------------------------------

        var fd = new FormData();
        var myfile = this.selectFileCarrier.name;
        var ext = myfile.split(".").pop();
        if (ext == "csv") {
          if (fd.has("file")) {
            fd.set("file", this.selectFileCarrier);
          } else {
            fd.append("file", this.selectFileCarrier);
          }
          var body = fd;
          var headers = new Headers();
          let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieservice.get("user_access_token")));
          const token: string = "Bearer " + user_access_token;
          headers.append("Authorization", token);
          let options = new RequestOptions({ headers: headers });
          const apiUrl =
            environment.apiUrl +
            "/api/Carrier/ImportCarrierByCSV?id=" +
            this.carrierContractMasterId +
            "&Type=" +
            "Individual" +
            "&UserType=" +
            0;
          const req1 = this.anghttp
            .post(apiUrl, body, options)
            .map((response: Response) => response.json())
            .subscribe(
              (res) => {
                if (res == "OK") {
                  this.toastr.success("Rates Uploaded Successfully");
                  if (
                    NetworkComponent.networkComponent.EditContractDatatable !=
                    undefined
                  ) {
                    NetworkComponent.networkComponent.EditContractDatatable.destroy();
                  }
                  NetworkComponent.networkComponent.GetEditCarrierContractGetList(
                    this.carrierContractMasterId
                  );
                  NetworkComponent.networkComponent.EditContractDatatable.reload();
                  NetworkComponent.networkComponent.selectFileCarrier = null;
                  $("#btnUploadFile").val("");
                  $("#UploadRateModal").modal("hide");
                  Helpers.setLoading(false);
                } else {
                  NetworkComponent.networkComponent.selectFileCarrier = null;
                  $("#btnUploadFile").val("");
                  Helpers.setLoading(false);
                  swal(res, "", "warning");
                }
              },
              (err) => {
                if (err._body != undefined)
                  NetworkComponent.networkComponent.selectFileCarrier = null;
                $("#btnUploadFile").val("");
                Helpers.setLoading(false);
                swal(err._body.replace(/"/g, ""), "", "warning");
              }
            );
        } else {
          this.toastr.error("Upload only .csv files !", "Error");
        }
      }
    }, 2000);

  }

  SaveCarrierContractMaster() {
    if (this.ValidateCarrierContractMaster()) {
      if ($("#ContractStatus option:selected").text().trim() == "Authorized") {
        if (
          !this.commonService.CheckHasRight("AUTHORIZE", "CONTRACT_DETAILS")
        ) {
          this.toastr.error(
            "You do not have rights to Authorize this contract details!",
            "Error"
          );
          return;
        }
      }
      this.CarrierContractMaster.StartDate = moment(
        $("#StartDate").datepicker("getDate")
      ).format("YYYY-MM-DD");
      this.CarrierContractMaster.EndDate = moment(
        $("#EndDate").datepicker("getDate")
      ).format("YYYY-MM-DD");
      this.CarrierContractMaster.ApprovedOn = moment(
        $("#ApprovedOn").datepicker("getDate")
      ).format("YYYY-MM-DD");
      this.CarrierContractMaster.LastUpdatedOn = moment(
        $("#LastUpdatedOn").datepicker("getDate")
      ).format("YYYY-MM-DD");
      this.CarrierContractMaster.LastPriceRevisedOn = moment(
        $("#LastPriceRevisedOn").datepicker("getDate")
      ).format("YYYY-MM-DD");
      //this.CarrierContractMaster.EarlyPODdays = moment($('#EarlyPODdays').datepicker("getDate")).format('YYYY-MM-DD');
      this.CarrierContractMaster.CompanyId = this.Company.Id;
      //add kevin 23/10/2020
      this.CarrierContractMaster.IsMasterRate = 0;
      //end
      this._appService
        .Post(
          "Carrier",
          "SaveCarrierContractMaster",
          this.CarrierContractMaster
        )
        .subscribe(
          (response) => {
            if (response == 100) {
              swal(
                "There is already one Authorized  Contract exists for this network ! You can expire that contract and authorize this contract .",
                "",
                "warning"
              );
            } else {
              this.CarrierContractMaster.StartDate = moment(
                $("#StartDate").datepicker("getDate")
              ).format("YYYY-MM-DD");
              this.CarrierContractMaster.EndDate = moment(
                $("#EndDate").datepicker("getDate")
              ).format("YYYY-MM-DD");
              this.ClearValidationsContractMaster();
              this.carrierContractMasterId = response;

              this.ContractDatatable.destroy();
              this.GetContractList(this.Company.Id);
              this.toastr.success(
                "CarrierContractMaster data saved Successfully !",
                "Success"
              );
            }
          },
          (err) => {
            this.toastr.error("Error occurred while saving  Data !", "error");
          }
        );
    } else {
      this.toastr.error("Please Fill Required Details !", "Error");
    }
  }

  ClearValidationsContractMaster() {
    NetworkComponent.networkComponent.commonService.ClearMessage(
      $("#FieldSetType")
    );
  }

  onTranshipmentTap() {
    this.RefreshTranshipmentDropdown();
    this.GetCustomerVendorSelect2Data();

    if (this.TranshipmentDatatable) this.TranshipmentDatatable.destroy();
    this.GetTranshipmentPonitList(this.EditD2D);
  }

  onContractMasterTap() {
    if (this.ContractDatatable) this.ContractDatatable.destroy();
    this.GetContractList(this.EditD2D);
  }

  onProductTap() {
    if (this.ProductDataTable) this.ProductDataTable.destroy();
    this.GetProductDataList(this.EditD2D);
  }

  onPincodeTap() {
    if (this.PincodeDatatable) this.PincodeDatatable.destroy();
    this.DataTablePincode(this.EditD2D);
  }

  onContactTap() {
    if (this.ContactsDatatable) this.ContactsDatatable.destroy;
    this.GetContactsList(this.EditD2D);
  }

  onRegistrationTap() {
    this.registrationTypeList.forEach((element, index) => {
      this.CheckIsForLifeTime(index, element.IsForLifeTime);
      // this.getAttachmentList()
    });
  }
  //----------------------Exception Report------------------------

  GetUnmappedCities() {
    this._appService
      .GetById(
        "Report",
        "GetExceptionReports",
        NetworkComponent.networkComponent.CompanyId
      )
      .subscribe(
        (response) => {
          this.CityName = response.CityNamePincode;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
  }

  GetUnmappedCityForRate() {
    this._appService
      .GetById(
        "Report",
        "GetExceptionReports",
        NetworkComponent.networkComponent.CompanyId
      )
      .subscribe(
        (response) => {
          this.CityNameForRate = response.CityNameRate;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
  }

  GetUnmappedTransPoint() {
    this._appService
      .GetById(
        "Report",
        "GetExceptionReports",
        NetworkComponent.networkComponent.CompanyId
      )
      .subscribe(
        (response) => {
          this.CityTranshipment = response.CityTranshipment;
        },
        (err) => {
          this.toastr.error("Error occurred while fetching data !", "error");
        }
      );
  }
  //----------------------------------------------------------------

  GetOfficialSelectData() {
    $("#NCompanyCountry").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCountryWiseList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#NCompanyCountry").text("");
          return {
            query: params.term,
            page: params.page || 1,
            CategoryName: "Country",
            ParentId: null,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for your country",
    });

    $("#NCompanyState").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCountryWiseList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#NCompanyState").text("");
          return {
            query: params.term,
            page: params.page || 1,
            CategoryName: "State",
            ParentId: $("#NCompanyCountry").val(),
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for your state",
    });

    $("#NCompanyCity").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCountryWiseList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#NCompanyCity").text("");
          return {
            query: params.term,
            page: params.page || 1,
            CategoryName: "City",
            ParentId: $("#NCompanyState").val(),
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for your City",
    });
  }
  GetBillingSelectData() {
    $("#NCompanyCountryBilling").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCountryWiseList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#NCompanyCountryBilling").text("");
          return {
            query: params.term,
            page: params.page || 1,
            CategoryName: "Country",
            ParentId: null,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for your country",
    });

    $("#NCompanyStateBilling").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCountryWiseList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#NCompanyStateBilling").text("");
          return {
            query: params.term,
            page: params.page || 1,
            CategoryName: "State",
            ParentId: $("#NCompanyCountryBilling").val(),
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for your state",
    });

    $("#NCompanyCityBilling").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/GetCountryWiseList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#NCompanyCityBilling").text("");
          return {
            query: params.term,
            page: params.page || 1,
            CategoryName: "City",
            ParentId: $("#NCompanyStateBilling").val(),
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Search for your City",
    });
  }

  CheckIsForLifeTime(d, chk) {
    if (chk == true) {
      $("#NValidity_" + d).prop("disabled", true);
      $("#NValidity_" + d).val("");
    } else {
      $("#NValidity_" + d).prop("disabled", false);
    }
  }

  GetSelectData() {
    $("#NetworkAccountsType").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url:
          environment.apiUrl + "api/ChartsofAccount/GetAccountListforNetwork",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            query: params.term,
            page: params.page || 1,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Enter Account",
    });

    $("#SalesPerson").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/AccountingReport/GetUserDropDown",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          $("#SalesPerson").text("");
          return {
            query: params.term,
            page: params.page || 1,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          return {
            results: data.Results,
            pagination: {
              more: params.page * 30 < data.Total,
            },
          };
        },
      },
      tokenSeparators: [",", " "],

      placeholder: "Enter SalesPerson",
    });
    $("#SalesPerson").on("select2:select", function (e) {
      var data = e.params.data;
      NetworkComponent.that.SalesPerson = data.id;
      // console.log(NetworkComponent.that.anuuserid, "ActivitylogComponent");
    });
  }

  SaveData() {
    $("#BtnAuthorizeNetwork").prop("disabled", true);
    var flag = this.ValidateBasicInfoField();
    if (flag != false) {
      this.AccountData.Name = $("#FullName").val();
      this.AccountData.ParentId = $("#NetworkAccountsType").val();
      this.AccountData.IsActive = true;
      this.AccountData.AccountType = 2;
      this.AccountData.CompanyId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).Id;
      this.AccountData.TenantId = JSON.parse(
        localStorage.getItem("ChnageCompnayId")
      ).TenantId;
      if (this.AccountData.ParentId != "") {
        this._appService
          .GetByThreeId(
            "ChartsofAccount",
            "CheckAccountExist",
            this.AccountData.Id,
            this.AccountData.Name,
            this.AccountData.ParentId
          )
          .subscribe(
            (response) => {
              this._appService
                .Post("ChartsofAccount", "SaveAccount", this.AccountData)
                .subscribe(
                  (response) => {
                    this.Company.AccountTypeId = $(
                      "#NetworkAccountsType"
                    ).val();
                    this.Company.AccountId = response.Id;
                    this.AccountData.Id = this.Company.AccountId;
                    this.SaveBasicInfo("SaveAndNext");
                    setTimeout(() => {
                      this.AuthorizeNetwork();
                    }, 1000);
                    $("#BtnAuthorizeNetwork").prop("disabled", false);
                  },
                  (err) => {
                    this.toastr.error(
                      "Error occurred while saving data !",
                      "error"
                    );
                    $("#BtnAuthorizeNetwork").prop("disabled", false);
                  }
                );
            },
            (err) => {
              this.Company.AccountTypeId = $("#NetworkAccountsType").val();
              this.SaveBasicInfo("SaveAndNext");
              setTimeout(() => {
                this.AuthorizeNetwork();
              }, 1000);
              $("#BtnAuthorizeNetwork").prop("disabled", false);
            }
          );
      } else {
        this.Company.AccountTypeId = $("#NetworkAccountsType").val();
        this.SaveBasicInfo("SaveAndNext");
        setTimeout(() => {
          this.AuthorizeNetwork();
        }, 1000);
        $("#BtnAuthorizeNetwork").prop("disabled", false);
      }
    } else {
      const FillRequiredDetails = this.translate.instant("ALERTMESSAGES.FillRequiredDetails");
      this.toastr.error(FillRequiredDetails, 'error');
      $("#BtnAuthorizeNetwork").prop("disabled", false);
    }
  }
  //-------------------------Authorize------------------------
  AuthorizeNetwork() {
    Helpers.setLoading(true);
    this._appService
      .GetByThreeId(
        "Common",
        "AuthorizeTransaction",
        6,
        this.Company.Id,
        this.CompanyId
      )
      .subscribe(
        (response) => {
          // $("#BtnAuthorizeNetwork").prop('disabled', true);
          this.toastr.success("Network Authorized Successfully !", "Success");
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
    Helpers.setLoading(false);
  }

  //-------------------------Save Company---------------------------------------
  SaveCompany(ToDo) {
    Helpers.setLoading(true);
    if (this.Company.IsInsure == 1) {
      this.Company.isFOV_ROV = $("input[name='checkbox_isFOV_ROV']:checked").val();
    }
    ;
    if ($("#ShortageConsignmentlbl1").is(":checked") == true) {
      this.Company.IsIndentAsLR = true;
    } else {
      this.Company.IsIndentAsLR = false;
    }
    //added by rahul
    if ($("#DisableCompany").is(":checked") == true) {
      this.Company.Isdisable = true;
    } else {
      this.Company.Isdisable = false;
    }

    if (this.Company.InvoiceDue == null) {
      this.Company.InvoiceDue = 0;
    }

    if (this.Company.CreditLimit == null) {
      this.Company.CreditLimit = 0;
    }
    //end

    //added by vithujan 14-01-2023
    if (this.Company.DeliveryPartner != null && Array.isArray(this.Company.DeliveryPartner)) {
      this.Company.DeliveryPartner = this.Company.DeliveryPartner.join(', ');
    }
    console.log(this.Company);
    //added by rahul
    if (this.Company.FullName) {
      this.Company.FullName = this.Company.FullName.trimEnd();
    }
    //end
    this.Company.SalesPerson = $("#SalesPerson").val();

    this._appService.Post("Company", "SaveCompany", this.Company).subscribe(
      (response) => {
        this.Company.Id = response;
        //added by vithujan 11-01-2023
        this.NetworkId = this.Company.Id;
        //end
        this.ShowAttachment = true;
        if (ToDo == "SaveAndNext") {
          $("#divtopbar_companyInfo,#topbar_companyInfo").removeClass("active");
          $("#divtopbar_OtherDetails, #topbar_OtherDetails").addClass("active");
        }
        this.toastr.success(
          "Company Basic Information Saved Successfully !",
          "Success"
        );
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
    Helpers.setLoading(false);
  }

  ValidateBasicInfoField() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#FullName"),
        "Please Enter Company Full Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#ShortName"),
        "Please Enter Company Short Name",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#InvoiceDue"),
        "Please Enter Invoice Due",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField2(
        $("#NetworkAccountsType"),
        $("#FieldSetNetworkAccountsType"),
        "Please Select Account Type",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    $("[name='CompanyTransport[]']:checked").each(function () {
      if (
        $(this).parent().text().trim() !=
        "Customer"
      ) {
        if (
          !NetworkComponent.networkComponent.commonService.ValidateRequiredField2(
            $("#CompanyType"),
            $("#FieldSetCompanyType"),
            "Please Select Company Type",
            "after",
            ""
          )
        ) {
          flag = false;
        }
      }
    });
    return flag;
  }
  ClearBasicInfoValidation() {
    this.commonService.ClearMessage($("#FullName"));
    this.commonService.ClearMessage($("#ShortName"));
    this.commonService.ClearMessage($("#InvoiceDue"));
    this.commonService.ClearMessage($("#NetworkAccountsType"));
    this.commonService.ClearMessage($("#FieldSetNetworkAccountsType"));
    this.commonService.ClearMessage($("#CompanyType"));
    this.commonService.ClearMessage($("#FieldSetCompanyType"));
  }

  //----------------------- Save Other Details-----------------------------------

  SaveOtherDetails() {
    Helpers.setLoading(true);

    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      var flag = this.ValidationsOtherDetails();
      if (!flag) {
        Helpers.setLoading(false);
        return false;
      } else {
        this.OtherDetails.CompanyId = this.Company.Id;
        if (this.OtherDetails.TaxPreference == 'TaxExempt' && this.ExemptionReasonText == 'SEZ Customer' && this.SalesFlag == false) {
          this.OtherDetails.LUTBondStartDate = moment($('#LUTBondStartDate').datepicker("getDate")).format('YYYY-MM-DD');
          this.OtherDetails.LUTBondEndDate = moment($('#LUTBondEndDate').datepicker("getDate")).format('YYYY-MM-DD');
        } else {
          this.OtherDetails.LUTBondStartDate = null;
          this.OtherDetails.LUTBondEndDate = null;
        }

        this._appService
          .Post("Company", "OtherDetails", this.OtherDetails)
          .subscribe(
            (response) => {
              this.toastr.success("Save Data Successfully");
              $("#divtopbar_address,#topbar_address").addClass("active");
              $("#divtopbar_OtherDetails, #topbar_OtherDetails").removeClass(
                "active"
              );
            },
            (err) => {
              this.toastr.error("Error occurred while fetching data !", "error");
            }
          );
      }
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_OtherDetails, #topbar_OtherDetails").removeClass("active");
    }
    Helpers.setLoading(false);
  }

  ValidationsOtherDetails = function () {
    var flag = true;
    this.commonService.ClearMessage($("#FieldSetExemptionReason"));
    this.commonService.ClearMessage($("#ExemptionReason"));
    this.commonService.ClearMessage($("#LUTBondNumber"));
    this.commonService.ClearMessage($("#LUTBondStartDate"));
    this.commonService.ClearMessage($("#LUTBondEndDate"));
    if (this.OtherDetails.TaxPreference == 'TaxExempt' && this.ExemptionReasonText == 'SEZ Customer' && this.SalesFlag == false) {
      if (!this.commonService.ValidateRequiredField2(
        $("#ExemptionReason"), $("#FieldSetExemptionReason"), "Please Select Exemption Reason", "after", ""
      )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#LUTBondNumber"), "Please enter LUT Bond Number", "after", ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#LUTBondStartDate"), "Please select LUT Bond Start Date", "after", ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#LUTBondEndDate"), "Please select LUT Bond End Date", "after", ""
        )
      ) {
        flag = false;
      }
    }
    return flag;
  }

  changeExemptionReason() {
    this.ExemptionReasonText = $("#ExemptionReason option:selected").text().trim();
  }

  //------------------------------Save Address-----------------------------------
  //added by rahul
  validateAddress() {
    var flag = true;
    if (this.hostUrl == 'https://isa.ifreightbox.net/') {
      if (
        !this.commonService.ValidateRequiredField(
          $("#OfficeAddress"),
          "Please Enter Office Address",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#NCompanyCountry"),
          "Please Enter Company Country",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#NCompanyState"),
          "Please Enter Company State",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#NCompanyCity"),
          "Please Enter Company City",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#OfficePostalCode"),
          "Please Enter Office Postal Code",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#OfficialPhone"),
          "Please Enter Phone number",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#BillingAddress"),
          "Please Enter Billing Address",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#NCompanyCityBilling"),
          "Please Enter city",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#NCompanyCountryBilling"),
          "Please Enter Country",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#NCompanyStateBilling"),
          "Please Enter state",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#BillingPostalCode"),
          "Please Enter Postal Code",
          "after",
          ""
        )
      ) {
        flag = false;
      }
      if (
        !this.commonService.ValidateRequiredField(
          $("#BillingAddressPhone"),
          "Please Enter Phone number",
          "after",
          ""
        )
      ) {
        flag = false;
      }
    }
    return flag;
  }
  //end
  SaveAddress() {
    //added by rahul
    var flag = this.validateAddress()
    //end 
    if (flag != false) {
      Helpers.setLoading(true);
      if (
        this.Company.Id != null &&
        this.Company.Id != undefined &&
        this.Company.Id != ""
      ) {
        this.OfficialAddress.CompanyId = this.Company.Id;
        this.BillingAddress.CompanyId = this.Company.Id;

        this.OfficialAddress.Country = $("#NCompanyCountry").val();
        this.OfficialAddress.State = $("#NCompanyState").val();
        this.OfficialAddress.City = $("#NCompanyCity").val();

        this.BillingAddress.Country = $("#NCompanyCountryBilling").val();
        this.BillingAddress.State = $("#NCompanyStateBilling").val();
        this.BillingAddress.City = $("#NCompanyCityBilling").val();

        this.CompanyAddress.OfficialAddress = this.OfficialAddress;
        this.CompanyAddress.BillingAddress = this.BillingAddress;
        this.CompanyAddress.OfficialAddress.IsNetworkCompany = true;
        this.CompanyAddress.BillingAddress.IsNetworkCompany = true;
        this._appService
          .Post("Company", "SaveCompanyAddress", this.CompanyAddress)
          .subscribe(
            (response) => {
              this.CompanyAddress.OfficialAddress.Id = response.OfficeAddress;
              this.CompanyAddress.BillingAddress.Id = response.BillingAddress;
              this.OfficialAddress.Id = response.OfficeAddress;
              this.BillingAddress.Id = response.BillingAddress;
              $(
                "#divtopbar_address,#divtopbar_companyInfo, #divtopbar_financials, #divtopbar_registration, #divtopbar_social, #divtopbar_summary, #topbar_companyInfo, #topbar_address, #topbar_financials, #topbar_registration, #topbar_social, #topbar_summary"
              ).removeClass("active");
              $("#divtopbar_contacts, #topbar_contacts").addClass("active");
              this.GetContactsList(this.EditD2D);
              if (this.registrationTypeList.length == 0) {
                this.GetRegistrationData();
                this.GetShipmentAllocatioRule();
              }

              this.toastr.success("Address data saved Successfully !", "Success");
            },
            (err) => {
              this.toastr.error(
                "Error occurred while saving Address data !",
                "error"
              );
            }
          );
      } else {
        this.toastr.error("Please Fill Basic Information!", "Required");
        $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
        $("#divtopbar_address, #topbar_address").removeClass("active");
      }

      Helpers.setLoading(false);
    }
  }

  ShowData() {
    if (this.OtherDetails.TDSPreference == "Deducted") {
      this.showTDSDropdown = true;
      this.OtherDetails.ManageTdsId = null;
      this.RefreshParentCompany();
    } else {
      this.showTDSDropdown = false;
      this.OtherDetails.ManageTdsId = null;
      this.RefreshParentCompany();
    }
  }

  CopyMasterContract() {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      this._appService.GetById("Company", "GetCompanyType", this.Company.Id).subscribe((response) => {
        this.CompanyMasterType = response;

        var MasterType = 1;
        for (const item of this.CompanyMasterType.length) {
          if (item.Name == 'Transporter') {
            MasterType = 1;
            break;
          } else if (item.Name == 'Manufacturer') {
            MasterType = 2;
            break;
          }
        }

        this._appService.GetByTwoId("MasterRateContract", "InsertCopyMasterRate", this.Company.Id, MasterType).subscribe((response) => {
          swal("Contract Copied successfully !", "", "success");
          this.ContractDatatable.reload();
          // this.CompanyType = response;
          //this.RefreshParentCompany();
        },
          (err) => {
            this.toastr.error(
              "Error occurred while fetching TyresDesignPattern !",
              "error"
            );
          }
        );

      },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching TyresDesignPattern !",
            "error"
          );
        }
      );
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_Contract,#topbar_Contract").addClass("active");
    }
  }
  // Bank Details
  onBankAccountTap() {
    NetworkComponent.networkComponent.GetBankAccountList(this.EditD2D);
  }

  NewBankAccount() {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      this.AccountDetail = {};
      $("#BankDetailsModal1").modal("show");
      this.ClearValidationsForBankDetails();
    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_bankaccounts, #topbar_bankaccounts").removeClass("active");
    }
  }

  GetBankAccountList(ID) {
    this.AccountDetailsDatatable = (<any>(
      $("#m_datatable_BankAccounts")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Network/GetBankAccountList",
            params: {
              // custom parameters
              CompanyId: ID,
              TenantId: NetworkComponent.networkComponent.TenantId,
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      search: {
        onEnter: true,
        input: $("#ContactName"),
        delay: 400,
      },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("id");
              NetworkComponent.networkComponent._appService
                .GetById("Network", "GetCompanyAccountDetail", Id)
                .subscribe(
                  (response) => {
                    NetworkComponent.networkComponent.AccountDetail = response;
                    $("#BankDetailsModal1").modal("show");
                  },
                  (err) => {
                    console.log("Error occured");
                  }
                );
            });

          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent.ClearValidationsForBankDetails();
                  NetworkComponent.networkComponent._appService
                    .Delete("Network", "DeleteAccountDetail", Id)
                    .subscribe(
                      (response) => {
                        NetworkComponent.networkComponent.toastr.success(
                          "Bank details Deleted Successfully !",
                          "Success"
                        );
                        NetworkComponent.networkComponent.AccountDetailsDatatable.reload();
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
        },
      },

      columns: [
        { field: "Bank", title: "Bank" },
        { field: "Branch", title: "Branch", filterable: !1 },
        { field: "AccountNo", title: "AccountNo", filterable: !1 },
        { field: "IFSCCode", title: "IFSCCode", filterable: !1 },
        {
          field: "Actions",
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "VIEW",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}"class="btnEdit m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit details"><i class="la la-edit"></i></a>`;
            }
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE",
                "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete"><i class="la la-trash"></i>`;
            }
            return btn;
          },
        },
      ],
    });
  }
  // For Bank Account
  SaveAccount() {
    Helpers.setLoading(true);
    var flag = this.ValidateField();
    if (flag != false) {
      if (
        this.Company.Id != "undefined" &&
        this.Company.Id != null &&
        this.Company.Id != ""
      ) {
        this.AccountDetail.CompanyId = this.Company.Id;
        this._appService
          .Post("Network", "SaveCompanyAccountDetail", this.AccountDetail)
          .subscribe(
            (response) => {
              $("#BankDetailsModal1").modal("hide");
              // this.GetBankAccountList(this.Company.Id);
              NetworkComponent.networkComponent.GetBankAccountList(
                this.Company.Id
              );
              this.toastr.success(
                "Bank details saved Successfully !",
                "Success"
              );
            },
            (err) => {
              this.toastr.error("Error occurred while saving data !", "error");
            }
          );
      }
    } else {
      const FillRequiredDetails = this.translate.instant("ALERTMESSAGES.FillRequiredDetails");
      this.toastr.error(FillRequiredDetails, 'error');
    }

    Helpers.setLoading(false);
  }

  ValidateField() {
    var flag = true;
    if (
      !this.commonService.ValidateRequiredField(
        $("#AccountNoForCompany"),
        "Please Enter Account No",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    if (
      !this.commonService.ValidateRequiredField(
        $("#BankForCompany"),
        "Please Enter Bank",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#BranchForCompany"),
        "Please Enter Branch",
        "after",
        ""
      )
    ) {
      flag = false;
    }
    if (
      !this.commonService.ValidateRequiredField(
        $("#IFSCCodeForCompany"),
        "Please Enter IFSC Code",
        "after",
        ""
      )
    ) {
      flag = false;
    }

    return flag;
  }

  ClearValidationsForBankDetails() {
    NetworkComponent.networkComponent.commonService.ClearMessage(
      $("#AccountNoForCompany")
    );
    NetworkComponent.networkComponent.commonService.ClearMessage(
      $("#BankForCompany")
    );
    NetworkComponent.networkComponent.commonService.ClearMessage(
      $("#BranchForCompany")
    );
    NetworkComponent.networkComponent.commonService.ClearMessage(
      $("#IFSCCodeForCompany")
    );
  }

  OnInsertLogoClick() {
    $("#NetworkLogo").trigger("click");
  }

  OnUploadLogoClick(event) {
    this.selectFile = event.target.files[0];
    if (
      this.selectFile == undefined ||
      this.selectFile == "" ||
      this.selectFile == null
    ) {
      this.toastr.error("Please select file to upload", "error");
      return false;
    }

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    var fileReader = new FileReader();
    var isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
      var header = "";

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (header.toUpperCase() != '89504E47' && header.toUpperCase() != 'FFD8FFE0' && header.toUpperCase() != 'FFD8FFE1') {
        NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.ImageOnly"), 'Error');
        $("#NetworkLogo").val();
        isValidFileType = false;
        Helpers.setLoading(false);
        return false;
      }
    };
    fileReader.readAsArrayBuffer(this.selectFile);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
        if (!format.test(this.selectFile.name)) {
          this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
          $("#NetworkLogo").val("");
          Helpers.setLoading(false);
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        var meme_type = this.selectFile.type;
        if ((meme_type.toLowerCase() != "image/jpeg") && (meme_type.toLowerCase() != "image/png")) {
          this.toastr.error(this.translate.instant("SETTING.ImageOnly"), 'Error');
          $("#NetworkLogo").val();
          Helpers.setLoading(false);
          return false;
        }

        //--------------Size Validation----------------
        var bytesize = this.selectFile.size;
        var kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
          $("#NetworkLogo").val();
          Helpers.setLoading(false);
          return false;
        }
        //----------------------------------------------

        var myfile = this.selectFile.name;
        var ext = myfile.split(".").pop();
        if (ext == "jpg" || ext == "png" || ext == "jpeg") {
          var fd = new FormData();
          if (fd.has("file")) {
            fd.set("file", this.selectFile);
          } else {
            fd.append("file", this.selectFile);
          }

          var headers = new Headers();
          let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieservice.get("user_access_token")));
          const token: string = "Bearer " + user_access_token;
          headers.append("Authorization", token);
          let options = new RequestOptions({ headers: headers });
          const apiUrl = environment.apiUrl + "/api/Network/UploadLogo";

          const req1 = this.anghttp.post(apiUrl, fd, options).subscribe(
            (response) => {
              let NewPic: string = JSON.parse(response["_body"]);
              this.Company.FileName = NewPic.split(".")[0];
              this.Company.FileExtension = NewPic.split(".")[1];
              var path = environment.apiUrl + "../../Document/Logos/" + NewPic;
              $("#ShowNetworkLogo").attr("src", path);
              if (
                this.Company.Id != null &&
                this.Company.Id != undefined &&
                this.Company.Id != ""
              ) {
                this.SaveBasicInfo("Save");
              }

              const updatesucess = this.translate.instant("ALERTMESSAGES.updatesucess");
              this.toastr.success(updatesucess, "Success");
            },
            (err) => {
              this.toastr.error("Error occured while Uploading...", "error");
            }
          );
        } else {
          this.toastr.error(
            "Only JPG and PNG file extensions are allowed !",
            "error"
          );
        }
      }
    }, 2000);

  }
  //--------------------------Attachment------------------------
  OnAttachmentClick() {
    $("#DocumentFrom").val("Network");
    this.AttachmentChild.DocumentType = "Network";
    this.AttachmentChild.DocumentTransaction = this.Company.Id;
    this.AttachmentChild.IsSearchHidden = true;
    if (this.AttachmentChild.datatable) {
      this.AttachmentChild.datatable.destroy();
      this.AttachmentChild.GetDocumentsList();
      this.AttachmentChild.datatable.search(
        this.AttachmentChild.DocumentTransaction,
        "ReferenceId"
      );
    }
  }
  masterEditNetwork(Data) {
    if (Data.Action == "Edit") this.GetNetworkById(Data.Id);
    if (Data.Action == "Delete") this.DeleteNetworkById(Data.Id);
  }

  warehouseUploadFile(file) {
    Helpers.setLoading(true);
    this.warehouseSelectFile = file.target.files[0];

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    var fileReader = new FileReader();
    var isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
      var header = "";

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (header.toUpperCase() != 'D0CF11E0' && header.toUpperCase() != '504B34') {
        NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.XLXOnly"), 'Error');
        $("#warehouseUpload").val("");
        isValidFileType = false;
        Helpers.setLoading(false);
        return false;
      }
    };
    fileReader.readAsArrayBuffer(this.warehouseSelectFile);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
        if (!format.test(this.warehouseSelectFile.name)) {
          this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
          $("#warehouseUpload").val("");
          Helpers.setLoading(false);
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        var meme_type = this.warehouseSelectFile.type;
        if ((meme_type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (meme_type.toLowerCase() != "application/vnd.ms-excel")) {
          this.toastr.error(this.translate.instant("SETTING.XLXOnly"), 'Error');
          $("#warehouseUpload").val("");
          Helpers.setLoading(false);
          return;
        }

        //--------------Size Validation----------------
        var bytesize = this.warehouseSelectFile.size;
        var kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
          $("#warehouseUpload").val("");
          Helpers.setLoading(false);
          return;
        }
        //----------------------------------------------

        var Extension = this.warehouseSelectFile.name
          .split(".")
          .pop()
          .toLowerCase();
        if (Extension == "xls" || Extension == "xlsx") {
          if (file.target.files && file.target.files[0]) {
            var fd = new FormData();
            if (fd.has("Warehousefile")) {
              fd.set("Warehousefile", this.warehouseSelectFile);
            } else {
              fd.append("Warehousefile", this.warehouseSelectFile);
            }
            this.warehouseSelectFile = {};
            const apiUrl =
              environment.apiUrl +
              "/api/Network/ManualUploadWarehouseData?CompanyId=" +
              this.Company.Id +
              "&UserId=" +
              this.userId;
            this.http.post(apiUrl, fd).subscribe(
              (response) => {
                $("#warehouseUpload").val("");
                this.toastr.success(
                  "Warehouse data saved Successfully !",
                  "success"
                );
                this.GetTranshipmentPonitList(this.EditD2D);
                // this.inwardGetList();
                Helpers.setLoading(false);
              },
              (err) => {
                Helpers.setLoading(false);
                $("#warehouseUpload").val("");
                this.toastr.error(
                  "Error occurred while uploading sheet !",
                  "error"
                );
                // this.toastr.error(err._body.replace(/"/g, ""), "error");
              }
            );
          }
        } else {
          this.toastr.error("Please select excel only !", "error");
          Helpers.setLoading(false);
        }
      }
    }, 2000);
  }

  warehouseUploadFile_AllCustomer(file) {
    Helpers.setLoading(true);
    this.warehouseSelectFile = file.target.files[0];

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    var fileReader = new FileReader();
    var isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
      var header = "";

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (header.toUpperCase() != 'D0CF11E0' && header.toUpperCase() != '504B34') {
        NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.XLXOnly"), 'Error');
        $("#warehouseUpload_AllCustomer").val("");
        isValidFileType = false;
        Helpers.setLoading(false);
        return false;
      }
    };
    fileReader.readAsArrayBuffer(this.warehouseSelectFile);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
        if (!format.test(this.warehouseSelectFile.name)) {
          this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
          $("#warehouseUpload_AllCustomer").val("");
          Helpers.setLoading(false);
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        var meme_type = this.warehouseSelectFile.type;
        if ((meme_type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (meme_type.toLowerCase() != "application/vnd.ms-excel")) {
          this.toastr.error(this.translate.instant("SETTING.XLXOnly"), 'Error');
          $("#warehouseUpload_AllCustomer").val("");
          Helpers.setLoading(false);
          return;
        }

        //--------------Size Validation----------------
        var bytesize = this.warehouseSelectFile.size;
        var kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
          $("#warehouseUpload_AllCustomer").val("");
          Helpers.setLoading(false);
          return;
        }
        //----------------------------------------------

        var Extension = this.warehouseSelectFile.name
          .split(".")
          .pop()
          .toLowerCase();
        if (Extension == "xls" || Extension == "xlsx") {
          if (file.target.files && file.target.files[0]) {
            var fd = new FormData();
            if (fd.has("Warehousefile")) {
              fd.set("Warehousefile", this.warehouseSelectFile);
            } else {
              fd.append("Warehousefile", this.warehouseSelectFile);
            }
            this.warehouseSelectFile = {};
            const apiUrl =
              environment.apiUrl +
              "/api/Network/ManualUploadWarehouseData_AllCustomer?CompanyId=" +
              this.Company.Id +
              "&UserId=" +
              this.userId;
            this.http.post(apiUrl, fd).subscribe(
              (response) => {
                $("#warehouseUpload_AllCustomer").val("");
                this.toastr.success(
                  "Warehouse data saved Successfully !",
                  "success"
                );
                this.GetTranshipmentPonitList(this.EditD2D);
                // this.inwardGetList();
                Helpers.setLoading(false);
              },
              (err) => {
                Helpers.setLoading(false);
                $("#warehouseUpload_AllCustomer").val("");
                this.toastr.error(
                  "Error occurred while uploading sheet !",
                  "error"
                );
                // this.toastr.error(err._body.replace(/"/g, ""), "error");
              }
            );
          }
        } else {
          this.toastr.error("Please select excel only !", "error");
          Helpers.setLoading(false);
        }
      }
    }, 2000);
  }

  //add kevin 08/02/2021
  CheckGSTCNO(ctrl, ValidationPosition) {
    const validGSTNO = 'Invalid GST No.';
    var regex = /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){1}([0-9a-zA-Z]){1}?$/;
    if (regex.test(ctrl) == true || ctrl == undefined) {
      return true;
    }
    else {
      $(ctrl).closest(".form-group").addClass("has-error");
      this.loading = false;
      this.toastr.warning(validGSTNO, "Warning");
      return false;
    }

  }
  //end

  chageFleetRequirements(FleetRequirements) {
    if (FleetRequirements == '1To20') {
      this.OneToTwenty = true;
      this.TwentyoneToForty = false;
      this.FortyoneToSixty = false;
      this.AboveSixty = false;
    }
    if (FleetRequirements == '21To40') {
      this.OneToTwenty = false;
      this.TwentyoneToForty = true;
      this.FortyoneToSixty = false;
      this.AboveSixty = false;
    }
    if (FleetRequirements == '41To60') {
      this.OneToTwenty = false;
      this.TwentyoneToForty = false;
      this.FortyoneToSixty = true;
      this.AboveSixty = false;
    }
    if (FleetRequirements == '60Above') {
      this.OneToTwenty = false;
      this.TwentyoneToForty = false;
      this.FortyoneToSixty = false;
      this.AboveSixty = true;
    }
  }

  // GetDeliveryPartnerSelect() {
  //   $("#se2_DeliveryPartner_net").each(function () {
  //     $(this).select2({
  //       tags: false,
  //       width: "100%",
  //       escapeMarkup: function (markup) {
  //         return markup;
  //       },
  //       minimumInputLength: 2,
  //       ajax: {
  //         global: false,
  //         url: environment.apiUrl + "api/Booking/GetTransporterSelectList",
  //         delay: 300,
  //         dataType: "json",
  //         allowClear: true,
  //         data: function (params) {
  //           return {
  //             query: params.term,
  //             page: params.page || 1,
  //             TenantId: NetworkComponent.networkComponent.TenantId,
  //           };
  //         },
  //         processResults: function (data, params) {
  //           params.page = params.page || 1;
  //           return {
  //             results: data.Results,
  //             pagination: {
  //               more: params.page * 30 < data.Total,
  //             },
  //           };
  //         },
  //       },
  //       tokenSeparators: [","],
  //       placeholder: "Enter Transporter Name",
  //     });
  //   });
  //   $("#se2_DeliveryPartner_net").on("select2:select", function (e) {
  //     var data = e.params.data;
  //     NetworkComponent.networkComponent.Company.DeliveryPartner = data.id;
  //   });
  // }

  closeModel_TransshipmentPoint() {
    $("#newTransshipment").modal("hide");
  }

  GetDefaultNetworkAccountsType() {
    this._appService.Get("Network", "nt_GetDefaultNetworkAccountsType").subscribe((response) => {
      this.DefaultNetworkAccountsType = response;
    });
  }

  transportCheckChange(i) {
    this.transportTypesList[i].selected = !this.transportTypesList[i].selected;
    var SelectedTransportIdsAttay: any = [];
    $("[name='CompanyTransport[]']:checked").each(function () {
      SelectedTransportIdsAttay.push($(this).val());
    });
    var selectedTransportTpe = '';
    this.transportTypesList.forEach(element => {
      SelectedTransportIdsAttay.forEach(element1 => {
        if (element.Id == element1) {
          selectedTransportTpe = selectedTransportTpe + element.Label;
        }
      });
    });
    if (selectedTransportTpe == 'Customer') {
      this.DefaultNetworkAccountsType.forEach(element => {
        if (element.IsDefaultGroupForCustomer == true) {
          if (element.Id != null) {
            this.Company.AccountTypeId = element.Id;
            this.Company.AccountTypeName = element.Name;
            var Options = "";
            Options += '<option value="' + this.Company.AccountTypeId + '">' +
              this.Company.AccountTypeName + "</option>";
            $("#NetworkAccountsType").html(Options);
            $("#NetworkAccountsType").val(this.Company.AccountTypeId).change();
          } else {
            this.Company.AccountTypeId = null;
            this.Company.AccountTypeName = null;
            var Options = "";
            Options += '<option value=""></option>';
            $("#NetworkAccountsType").html(Options);
            $("#NetworkAccountsType").val("").change();
          }
        }
      });
    }
    else if (selectedTransportTpe == 'Road Freight') {
      this.DefaultNetworkAccountsType.forEach(element => {
        if (element.IsDefaultGroupForTransporter == true) {
          if (element.Id != null) {
            this.Company.AccountTypeId = element.Id;
            this.Company.AccountTypeName = element.Name;
            var Options = "";
            Options += '<option value="' + this.Company.AccountTypeId + '">' +
              this.Company.AccountTypeName + "</option>";
            $("#NetworkAccountsType").html(Options);
            $("#NetworkAccountsType").val(this.Company.AccountTypeId).change();
          } else {
            this.Company.AccountTypeId = null;
            this.Company.AccountTypeName = null;
            var Options = "";
            Options += '<option value=""></option>';
            $("#NetworkAccountsType").html(Options);
            $("#NetworkAccountsType").val("").change();
          }
        }
      });
    }
    else if (selectedTransportTpe == 'Vendor') {
      this.DefaultNetworkAccountsType.forEach(element => {
        if (element.IsDefaultGroupForVendor == true) {
          if (element.Id != null) {
            this.Company.AccountTypeId = element.Id;
            this.Company.AccountTypeName = element.Name;
            var Options = "";
            Options += '<option value="' + this.Company.AccountTypeId + '">' +
              this.Company.AccountTypeName + "</option>";
            $("#NetworkAccountsType").html(Options);
            $("#NetworkAccountsType").val(this.Company.AccountTypeId).change();
          } else {
            this.Company.AccountTypeId = null;
            this.Company.AccountTypeName = null;
            var Options = "";
            Options += '<option value=""></option>';
            $("#NetworkAccountsType").html(Options);
            $("#NetworkAccountsType").val("").change();
          }
        }
      });
    } else {
      this.Company.AccountTypeId = null;
      this.Company.AccountTypeName = null;
      var Options = "";
      Options += '<option value=""></option>';
      $("#NetworkAccountsType").html(Options);
      $("#NetworkAccountsType").val("").change();
    }
  }

  GetCustomerConversionFactorList(companyId) {
    this._appService.GetById("OrdersByVehicle", "oc_GetCustomerConversionFactorList", companyId).subscribe((response) => {
      this.CustomerConversionFactorList = response;
      console.log(response);
      setTimeout(() => {
        (<any>$("#ConversionFactor")).selectpicker("refresh");
      }, 100);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching transport service data !", "error");
      });
  }

  updateFlag() {
    ;
    if ($("#ShortageConsignmentlbl1").is(":checked") == true) {
      this.Company.IsIndentAsLR = true;
    } else {
      this.Company.IsIndentAsLR = false;
    }
  }

  //added by vithujan 20-09-2022
  OnOpenModalWarehouse() {
    $(".UploadInstructions").modal("show");
  }

  OnOpenModalPincode() {
    $(".UploadInstructions1").modal("show");
  }
  //end

  // added by vithujan 30-12-2022
  GetParentCompanyCountry() {
    this._appService
      .Get("Company", "GetParentCompanyCountry")
      .subscribe(
        (response) => {

          let Country1 = "";
          Country1 =
            '<option value="' +
            response[0].Country +
            '">' +
            response[0].Country +
            "</option>";
          $("#NCompanyCountry").html(Country1);
          $("#NCompanyCountry").val(response[0].Country).change();

          let Country = "";
          Country =
            '<option value="' +
            $("#NCompanyCountry").val() +
            '">' +
            $("#NCompanyCountry").val() +
            "</option>";
          $("#NCompanyCountryBilling").html(Country);
          $("#NCompanyCountryBilling").val($("#NCompanyCountry").val()).change();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error"
          );
        }
      );
  }
  //end

  onCompanyBranchTap() {
    this.cb_isDefault = false;
    if ($("#se2_branch").select2()) {
      $("#se2_branch").val("");
      $("#se2_branch").select2("destroy");
    }
    this.GetShipment();
    if (this.CompanyBrnachDatatable) this.CompanyBrnachDatatable.destroy();
    this.GetcompanyBranchList(this.EditD2D);
  }

  GetcompanyBranchList(ID) {
    this.CompanyBrnachDatatable = (<any>(
      $("#m_datatable_Branch")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Company/cb_CompanygetBranchList",
            params: {
              // custom parameters
              CompanyId: ID,
              SearchValue: '',
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      // search: {
      //   onEnter: true,
      //   input: $("#CarrierNameSearch"),
      //   delay: 400,
      // },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnEdit")
            .click(function () {
              var Id = $(this).attr("id");
              NetworkComponent.networkComponent._appService
                .GetById("Carrier", "GetCarrierById", Id)
                .subscribe(
                  (response) => {
                    NetworkComponent.networkComponent.TransshipmentPointModel = response;
                    NetworkComponent.networkComponent.Contacts.EscalationLevel =
                      response.EscalationLevel;
                    NetworkComponent.networkComponent.RefreshSelect2();
                    if (response.OwnershipId != null) {
                      var Options =
                        '<option value="' +
                        response.OwnershipId +
                        '">' +
                        response.OwnershipName +
                        "</option>";
                      $("#SelectTranshipOwnership").html(Options);
                      $("#SelectTranshipOwnership")
                        .val(response.OwnershipId)
                        .change();
                    }
                    NetworkComponent.networkComponent.RefreshTranshipmentDropdown();
                    $("#newTransshipment").modal("show");
                  },
                  (err) => {
                    console.log("Error occured");
                  }
                );
            });

          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService
                    .GetById("Company", "cb_deleteCompanyBranch", Id)
                    .subscribe(
                      (response) => {
                        swal("Branch deleted successfully !", "", "success");
                        NetworkComponent.networkComponent.CompanyBrnachDatatable.reload();
                      },
                      (err) => {
                        console.log("Error occured");
                      }
                    );
                }
              });
            });
        },
      },
      columns: [
        {
          field: "BranchName", title: "Branch", textAlign: "left", filterable: !1
        },
        {
          field: "IsDefault", title: "IsDefault", textAlign: "left", filterable: !1
        },
        {
          field: "Actions",
          width: 110,
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          textAlign: "left",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE", "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                        <i class="la la-trash"></i>
                      </a>`;
            }
            return btn;
          },
        },
      ],
    });
  }

  GetShipment() {
    $("#se2_branch").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/getBranchList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: params.term
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for branch",
    });

    $("#se2_branch").on("select2:select", function (e) {
      var data = e.params.data;
      // NetworkComponent.networkComponent.shipment = data.id;
    });
  }

  cb_addCopmanyBranch() {
    if (
      !this.commonService.ValidateRequiredField2(
        $("#se2_branch"),
        $("#FieldSetse2_branch"),
        "Please Select Branch",
        "after",
        ""
      )
    ) {
      return false;
    }

    this._appService.GetByFourId("Company", "cb_AddComapnyBranch", this.EditD2D, $("#se2_branch").val(), this.cb_isDefault, this.userId)
      .subscribe(
        (response) => {
          Helpers.setLoading(false);
          this.toastr.success("Data saved Successfully !", "Success");
          NetworkComponent.networkComponent.CompanyBrnachDatatable.reload();
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  //added by vithujan 17-01-2023
  GetDeliveryPartnerSelect() {
    this._appService.GetById("Booking", "GetDeliveryPartnerList", this.TenantId).subscribe(
      (response) => {
        this.DeliveryPartnerList = response;

        setTimeout(function () {
          (<any>$("#se2_DeliveryPartner_net")).selectpicker("refresh");
        }, 200);
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Delivery Partner data !",
          "error"
        );
      }
    );
  }

  GetDeliveryPartnerListByIds() {
    var separatedArray = '';
    if (NetworkComponent.networkComponent.Company.DeliveryPartner != null && NetworkComponent.networkComponent.Company.DeliveryPartner != undefined) {
      separatedArray = NetworkComponent.networkComponent.Company.DeliveryPartner.split(', ');
    } else {
      separatedArray = null;
    }
    this._appService.GetByTwoId("Network", "GetDeliveryPartnerListByIds", separatedArray, this.TenantId).subscribe(
      (response) => {

        var autocompVal = new Array();
        $.each(response, function (index, item) {
          autocompVal.push(item.Id);
        });
        NetworkComponent.networkComponent.Company.DeliveryPartner = autocompVal;

        setTimeout(function () {
          (<any>$("#se2_DeliveryPartner_net")).selectpicker("refresh");
        }, 200);

      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Delivery Partner data !",
          "error"
        );
      }
    );
  }

  //added by vithujan 07-03-2023
  DownloadWarehouse() {
    Helpers.setLoading(true);

    this._appService.GetById("Carrier", "GetTranshipmentPointsDownload", this.Company.Id).subscribe(response => {
      this.DownloadFile(response);
      Helpers.setLoading(false);
    })
  }
  //end

  onCompanySubCompanyTap() {
    this.cb_isDefault = false;
    if ($("#se2_SubCompany").select2()) {
      $("#se2_SubCompany").val("");
      $("#se2_SubCompany").select2("destroy");
    }
    this.GetSubCompanySelectData();
    if (this.CompanySubCompanyDatatable) this.CompanySubCompanyDatatable.destroy();
    this.csc_CompanygetSubCompanyDataList(this.EditD2D);
  }

  csc_CompanygetSubCompanyDataList(ID) {
    this.CompanySubCompanyDatatable = (<any>(
      $("#m_datatable_SubCompany")
    )).mDatatable({
      data: {
        type: "remote",
        source: {
          read: {
            method: "POST",
            url: environment.apiUrl + "api/Company/csc_CompanygetSubCompanyDataList",
            params: {
              // custom parameters
              CompanyId: ID,
              SearchValue: '',
            },
            map: function (raw) {
              // sample data mapping
              var dataSet = raw;
              if (typeof raw.data !== "undefined") {
                dataSet = raw.data;
              }
              return dataSet;
            },
          },
        },
        pageSize: 10,
        serverPaging: !0,
        serverFiltering: !0,
      },
      layout: {
        class: "m--margin-top-5",
        scroll: false,
        footer: !1,
        smoothScroll: {
          scrollbarShown: true,
        },
      },
      sortable: !0,
      pagination: !0,
      toolbar: {
        items: {
          pagination: {
            pageSizeSelect: [10, 20, 30, 50, 100],
          },
        },
      },
      // search: {
      //   onEnter: true,
      //   input: $("#CarrierNameSearch"),
      //   delay: 400,
      // },
      rows: {
        afterTemplate: function (row, data, index) {
          $(row)
            .find(".btnDelete")
            .click(function (e) {
              var Id = $(this).attr("id");
              swal({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: !0,
                confirmButtonText: "Yes, delete it!",
              }).then(function (e) {
                if (e.value == true) {
                  NetworkComponent.networkComponent._appService.GetByTwoId("Company", "csc_deleteCompanySubCompany", Id, NetworkComponent.networkComponent.userId).subscribe((response) => {
                    swal("Sub Company deleted successfully !", "", "success");
                    if (NetworkComponent.networkComponent.CompanySubCompanyDatatable) {
                      NetworkComponent.networkComponent.CompanySubCompanyDatatable.destroy();
                    }
                    NetworkComponent.networkComponent.csc_CompanygetSubCompanyDataList(NetworkComponent.networkComponent.EditD2D);
                  },
                    (err) => {
                      console.log("Error occured");
                    }
                  );
                }
              });
            });
        },
      },
      columns: [
        {
          field: "SubCompanyName", title: "Company", textAlign: "left", filterable: !1
        },
        {
          field: "Actions",
          width: 110,
          title: "Actions",
          sortable: !1,
          overflow: "visible",
          textAlign: "left",
          template: function (t) {
            var btn = "";
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "DELETE", "NETWORK_DETAILS"
              )
            ) {
              btn += `<a id="${t.Id}" class="btnDelete m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete">
                        <i class="la la-trash"></i>
                      </a>`;
            }
            return btn;
          },
        },
      ],
    });
  }

  GetSubCompanySelectData() {
    $("#se2_SubCompany").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/Company/csc_getSubCompanyList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: NetworkComponent.networkComponent.EditD2D,
            param1: params.term
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Company",
    });
    $("#se2_SubCompany").on("select2:open", function (e) {
      $('#se2_SubCompany').val(null).trigger('change');
    });
    $("#se2_SubCompany").on("select2:select", function (e) {
      var data = e.params.data;
      // NetworkComponent.networkComponent.shipment = data.id;
    });
  }

  cb_addCopmanySubCompany() {
    if (
      !this.commonService.ValidateRequiredField2(
        $("#se2_SubCompany"),
        $("#FieldSetse2_SubCompany"),
        "Please Select Company",
        "after",
        ""
      )
    ) {
      return false;
    }

    this._appService.GetByFourId("Company", "csc_AddComapnySubCompany", this.EditD2D, $("#se2_SubCompany").val(), this.cb_isDefault, this.userId)
      .subscribe(
        (response) => {
          Helpers.setLoading(false);
          this.toastr.success("Data saved Successfully !", "Success");
          if (this.CompanySubCompanyDatatable) {
            this.CompanySubCompanyDatatable.destroy();
          }
          this.csc_CompanygetSubCompanyDataList(this.EditD2D);
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
  }

  //added by vithujan 22-07-2023
  GetAccountList() {
    $("#se2_Accounts").select2({
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 2,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/ChartsofAccount/GetSelectAccounts",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: params.term
          };
        },
        processResults: function (data) {
          return {
            results: data,
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Search for Accounts",
    });
  }

  GetSelectedAccount() {
    if (this.Company.Id != null) {
      this._appService.GetById("ChartsofAccount", "GetAccountById", this.Company.Id).subscribe(
        (response) => {

          var Options =
            '<option value="' +
            response.id +
            '">' +
            response.text +
            "</option>";
          $("#se2_Accounts").html(Options);
          $("#se2_Accounts")
            .val(response.id)
            .change();

        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Account data !",
            "error"
          );
        }
      );
    }
  }

  UpdateAccountId() {
    if (this.Company.Id != null) {
      this._appService.GetByTwoId("Company", "UpdateAccountId", this.Company.Id, $("#se2_Accounts").val()).subscribe(
        (response) => {

          this.toastr.success(this.translate.instant("VEHICLEMASTER.Successfully"));

          var Options =
            '<option value="' +
            response.id +
            '">' +
            response.text +
            "</option>";
          $("#se2_Accounts").html(Options);
          $("#se2_Accounts")
            .val(response.id)
            .change();

        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Account Data !",
            "error"
          );
        }
      );
    }
  }

  networkUploadFile(file) {
    Helpers.setLoading(true);
    this.networkSelectFile = file.target.files[0];

    //--------------File True Type Validation ---------- added by vithujan 22-09-2022
    var fileReader = new FileReader();
    var isValidFileType = true;
    fileReader.onloadend = function (e: any) {
      var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
      var header = "";

      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
      if (header.toUpperCase() != 'D0CF11E0' && header.toUpperCase() != '504B34') {
        NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.XLXOnly"), 'Error');
        $("#in_networkFileUpload").val("");
        isValidFileType = false;
        Helpers.setLoading(false);
        return false;
      }
    };
    fileReader.readAsArrayBuffer(this.networkSelectFile);
    //----------------------------------------------

    setTimeout(() => {
      if (isValidFileType == true) {
        //--------------Filename Validation ---------- added by vithujan 23-09-2022
        var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
        if (!format.test(this.networkSelectFile.name)) {
          this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
          $("#in_networkFileUpload").val("");
          Helpers.setLoading(false);
          return false;
        }
        //--------------File Type Validation ---------- added by vithujan 16-09-2022
        var meme_type = this.networkSelectFile.type;
        if ((meme_type.toLowerCase() != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (meme_type.toLowerCase() != "application/vnd.ms-excel")) {
          this.toastr.error(this.translate.instant("SETTING.XLXOnly"), 'Error');
          $("#in_networkFileUpload").val("");
          Helpers.setLoading(false);
          return;
        }

        //--------------Size Validation----------------
        var bytesize = this.networkSelectFile.size;
        var kbsize: any = 0;
        kbsize = (bytesize / 1000).toFixed(2);
        let IsFileSizeExceed = false;
        if (kbsize > 1024) {
          if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
          else IsFileSizeExceed = false;
        }
        if (IsFileSizeExceed) {
          this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
          $("#in_networkFileUpload").val("");
          Helpers.setLoading(false);
          return;
        }
        //----------------------------------------------


        var Extension = this.networkSelectFile.name.split(".").pop().toLowerCase();
        if (Extension == "xls") {
          if (file.target.files && file.target.files[0]) {
            var fd = new FormData();
            if (fd.has("NetworkDatafile")) {
              fd.set("NetworkDatafile", this.networkSelectFile);
            } else {
              fd.append("NetworkDatafile", this.networkSelectFile);
            }
            this.networkSelectFile = {};
            const apiUrl = environment.apiUrl + "/api/Network/net_ManualUploadNetworkData?UserId=" + this.userId + "&CompanyId=" + this.CompanyId;
            this.http.post(apiUrl, fd).subscribe(
              (response) => {
                if (response !== "Ok") {
                  $("#in_networkFileUpload").val("");
                  this.DownloadFile(response);
                  this.toastr.error("Please check downloaded file...", "error");
                  Helpers.setLoading(false);
                } else {
                  $("#in_networkFileUpload").val("");
                  this.toastr.success("Network data uploaded Successfully", "success");
                  Helpers.setLoading(false);
                }
              },
              (err) => {
                $("#in_networkFileUpload").val("");
                Helpers.setLoading(false);
                swal(err.error);
              }
            );
          }
        } else {
          this.toastr.error("Please select .xls files only !", "error");
          Helpers.setLoading(false);
        }
      }
    }, 500);

  }

  //add by maaria on 07-11-2023
  validateGSTCode(index: any, data: any, label: any) {
    if (label.includes("GST1")) {
      var stateName = $("#NCompanyState option:selected").text();
      if (data.length >= 2) {
        this._appService.GetByTwoId("Company", "GetMatchGST", stateName, data)
          .subscribe(
            (response) => {
              this.isValidGST = response;
            },
            (err) => {
              this.toastr.error("Error occurred while fetching data !", "error");
            }
          );
      }
    }
  }
  //end

  //add by maaria on 30-11-2023
  OnUlipGSTINClick() {
    this.commonService.ClearMessage($("#ULGstin"));
    $("#ULGstin").val(
      ""
    );
    $("#GSTINUlip").modal("show");
  }

  ValidateRequiredFieldUlip() {
    var flag = true;
    if (!this.commonService.ValidateRequiredField($("#ULGstin"), 'Please Enter GST No', 'after', '')) {
      flag = false;
    }
    return flag;
  }

  verifyUlipGSTIN() {
    var gstNo = $("#ULGstin").val();

    if (this.ValidateRequiredFieldUlip()) {
      Helpers.setLoading(true);

      this._appService
        .GetByOneParam("Company", "GetGSTINData", gstNo)
        .subscribe(
          (response) => {

            var message = JSON.parse(response.message);
            var responseObject = message.response[0].response;
            console.log('Response gst ', responseObject);
            var tradeName = responseObject.legalNameOfBusiness;
            var statejurisdiction = responseObject.stateJurisdiction;
            var stateJurisdictionCode = responseObject.stateJurisdictionCode;
            var gstnStatus = responseObject.gstnStatus;
            var constitutionOfBusiness = responseObject.constitutionOfBusiness;
            var gstIdentificationNumber = responseObject.gstIdentificationNumber;
            var dateOfRegistration = responseObject.dateOfRegistration;
            var eInvoiceStatus = responseObject.eInvoiceStatus;
            var taxpayerType = responseObject.taxpayerType;
            var OfficeAddress = responseObject.principalPlaceOfBusinessFields.principalPlaceOfBusinessAddress;
            var State = OfficeAddress.stateName;
            var OfficePostalCode = OfficeAddress.pincode;
            var floorNO = OfficeAddress.floorNumber;
            var buildingno = OfficeAddress.buildingNumber;
            var completeAddress = {
              buildingName: OfficeAddress.buildingName || "",
              floorNumber: OfficeAddress.floorNumber || "",
              buildingNumber: OfficeAddress.buildingNumber || "",
              city: OfficeAddress.city || "",
              landMark: OfficeAddress.landMark || "",
              streetName: OfficeAddress.streetName || "",
              districtName: OfficeAddress.districtName || "",
              stateName: OfficeAddress.stateName || "",
            };
            var completeAddressString = Object.values(completeAddress).filter(Boolean).join(', ');
            $("#FullName").val(tradeName);
            $("#OfficeAddress").val(completeAddressString);
            this.gstinData = response.gstinData;
            if (this.gstinData && Object.keys(this.gstinData).length > 0) {
              $("#GSTINUlip").modal("hide");
              $("#GSTINUlipdata").modal("show");
              $("#tradeNameSpan").text(tradeName);
              $("#statejurisdiction").text(statejurisdiction);
              $("#gstIdentificationNumber").text(gstIdentificationNumber);
              $("#gstnStatus").text(gstnStatus);
              $("#stateJurisdictionCode").text(stateJurisdictionCode);
              $("#completeAddressString").text(completeAddressString);
              $("#constitutionOfBusiness").text(constitutionOfBusiness);
              $("#dateOfRegistration").text(dateOfRegistration);
              $("#eInvoiceStatus").text(eInvoiceStatus);
              $("#taxpayerType").text(taxpayerType);
              $("#OfficePostalCode").val(OfficePostalCode);
              $("#in_OfficialAddressFloorNo").val(floorNO);
              $("#in_OfficialAddressFlatNo").val(buildingno);
              var OfficeState = "";
              OfficeState += '<option value="' + State + '">' + State + "</option>";
              $("#NCompanyState").html(OfficeState);
              $("#NCompanyState").val(State).change();
              Helpers.setLoading(false);
              // this.OnNewNetworkClick("true");
            }
            else {
              Helpers.setLoading(false);
              this.toastr.warning("Ulip Validation Unsuccessful! Please enter valid GST No!", 'warning');
            }
          },
          (err) => {
            Helpers.setLoading(false);
            this.toastr.error("An error occurred!", "error");
          }
        );
    }
  }


  verifiedgstindata() {
    this.OnNewNetworkClick("true");
    $("#GSTINUlipdata").modal("hide");
  }
  GetUlipSetting() {

    this.enableUlipForGSTIN = false;
    //first check in system setting then check whether it has rights as per role for ULIP
    this._appService.Get("VehicleMaster", "GetUlipSetting").subscribe(
      (response) => {
        if (response) {
          if (response.Value == "1") {
            localStorage.setItem("ulip-setting-S", "true");
            if (
              NetworkComponent.networkComponent.commonService.CheckHasRight(
                "VIEW",
                "ULIP_FOR_GSTIN"
              )
            ) {
              this.enableUlipForGSTIN = true;
            }
          }
          else {
            localStorage.setItem("ulip-setting-S", "false");
          }
        }
        else {
          localStorage.setItem("ulip-setting-S", "false");
        }
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );

    //end
  }
  //end

  RefreshvalidTimePicker() {
    // setTimeout(() => {
    $(".timepicker")
      .each(function () {
        if ($(this).data("timepicker")) {
          $(this).timepicker("remove");
        }
        $(this).timepicker({
          todayHighlight: 1,
          orientation: "down",
          autoclose: true,
          // defaultViewDate: new Date(),
          format: "hh:ii",
        });
      })
      .on("click", function () {
        $(".OpenDateTimePicker").not(this).timepicker("hide");
        $(".OpenDateTimePicker").not(this).removeClass("OpenDateTimePicker");
      });
    // }, 100);
  }

  timeConvert(timestart) {
    var hrs = Number(timestart.match(/^(\d+)/)[1]);
    var mnts = Number(timestart.match(/:(\d+)/)[1]);
    var format = timestart.match(/\s(.*)$/)[1];
    if (format == "PM" && hrs < 12) hrs = hrs + 12;
    if (format == "AM" && hrs == 12) hrs = hrs - 12;
    var hours = hrs.toString();
    var minutes = mnts.toString();
    if (hrs < 10) hours = "0" + hours;
    if (mnts < 10) minutes = "0" + minutes;
    var timeend = hours + ":" + minutes + ":00";
    return timeend; // return adjusted time or original string
  }

  GetDeliveryTimeWindowSelectData() {
    $("#se2_DeliveryTimeWindow").select2({
      tags: false,
      width: "100%",
      escapeMarkup: function (markup) {
        return markup;
      },
      minimumInputLength: 1,
      ajax: {
        global: false,
        url: environment.apiUrl + "api/TimeWindowMaster/twm_GetTimeWindowSelectDataList",
        delay: 300,
        dataType: "json",
        allowClear: true,
        data: function (params) {
          return {
            Id: NetworkComponent.networkComponent.CompanyId,
            param1: params.term
          };
        },
        processResults: function (data, params) {
          return {
            results: data
          };
        },
      },
      tokenSeparators: [","],
      placeholder: "Select Delivery Time Window",
    });
    $("#se2_DeliveryTimeWindow").on("select2:select", function (e) {
      var data = e.params.data;
      $("#in_DeliveryFromTimeWindow").val(data.FromTime);
      $("#in_DeliveryToTimeWindow").val(data.ToTime);
      setTimeout(() => {
        NetworkComponent.networkComponent.RefreshvalidTimePicker();
      }, 200);
    });
  }

  onDocumentChanges = (event: any, data: any): void => {
    data.UserId = this.Company.UserId;
    this.commonService.onChangeDocumentUpload(event, data);
  }
  //added by rahul 
  DisableCompany() {
    if ($("#DisableCompany").is(":checked") == true) {
      this.Company.Isdisable = true;
    } else {
      this.Company.Isdisable = false;
    }
  }
  //end;
  //added by rahul
  GetShipmentAllocatioRule() {
    if ($("#NCompanyCountry").val() != null) {
      this._appService
        .GetById(
          "Common",
          "GetLookByCategoryName",
          "Shipment Allocation Rule Criteria"
        )
        .subscribe(
          (response) => {
            this.shipmentAllocationRule = response;
            console.log(this.shipmentAllocationRule, 'shipmentAllocationRule')
          },
          (err) => {
            this.toastr.error(
              "Error occurred while getting registration data !",
              "error"
            );
          }
        );
    }

  }
  SaveShipmentallocaitonrule() {

    let hasError = false;
    this.shipmentAllocationRule.forEach((element, index) => {
      element.CompanyId = this.Company.Id;
      element.IsNetworkCompany = true;
      element.UserId = this.userId;
      if (element.Min > element.Max) {
        this.toastr.error('Minimum value should not be greater than maximum value', 'Error');
        hasError = true;
        return; // Early return to exit the loop
      }
    });
    if (hasError) {
      return;
    }



    this._appService
      .Post("Company", "SaveShipmentallocaitonrule", this.shipmentAllocationRule)
      .subscribe(
        (response) => {
          this.toastr.success(
            "Shipment allocaiton rule data saved Successfully !",
            "Success"
          );
          //added by vithujan 26-12-2022
          this.GetNetworkById(this.NetworkId);
        },
        (err) => {
          this.toastr.error(
            "Error occurred while saving Shipment allocaiton rule Data !",
            "error"
          );
        }
      );
  }
  //end

  cprd_uploadProduct(event) {
    if (
      this.Company.Id != null &&
      this.Company.Id != undefined &&
      this.Company.Id != ""
    ) {
      Helpers.setLoading(true);
      this.selectFile = event.target.files[0];

      //--------------File True Type Validation ---------- added by vithujan 22-09-2022
      var fileReader = new FileReader();
      var isValidFileType = true;
      fileReader.onloadend = function (e: any) {
        var arr = (new Uint8Array(e.target.result)).subarray(0, 4);
        var header = "";

        for (var i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }

        //89504E47 (PNG) || 25504446 (PDF) || FFD8FFE0(JPEG) || FFD8FFE1 (JPG) || D0CF11E0 (XLS) || 504B34 (XLSX) || 43686172 (CSV)
        if (header.toUpperCase() != 'D0CF11E0' && header.toUpperCase() != '504B34' && header.toUpperCase() != '43686172' && header.toUpperCase() != '5472616E') {
          NetworkComponent.networkComponent.toastr.error(NetworkComponent.networkComponent.translate.instant("SETTING.CSVXLS"), 'Error');
          $("#in_cprd_uploadProduct").val("");
          isValidFileType = false;
          Helpers.setLoading(false);
          return false;
        }
      };
      fileReader.readAsArrayBuffer(this.selectFile);
      //----------------------------------------------

      setTimeout(() => {
        if (isValidFileType == true) {
          //--------------Filename Validation ---------- added by vithujan 23-09-2022
          var format = /^[a-zA-Z0-9]*\.[a-zA-Z0-9]*$/;
          if (!format.test(this.selectFile.name)) {
            this.toastr.error(this.translate.instant("SETTING.InvalidFile"), 'Error');
            $("#in_cprd_uploadProduct").val("");
            Helpers.setLoading(false);
            return false;
          }
          //--------------File Type Validation ---------- added by vithujan 16-09-2022
          var meme_type = this.selectFile.type;
          if ((meme_type.toLowerCase() != "text/csv") && (meme_type.toLowerCase() != "application/vnd.ms-excel")) {
            this.toastr.error(this.translate.instant("SETTING.CSVXLS"), 'Error');
            $("#in_cprd_uploadProduct").val("");
            Helpers.setLoading(false);
            return;
          }

          //--------------Size Validation----------------
          var bytesize = this.selectFile.size;
          var kbsize: any = 0;
          kbsize = (bytesize / 1000).toFixed(2);
          let IsFileSizeExceed = false;
          if (kbsize > 1024) {
            if (kbsize / 1024 > environment.maxFileSize) IsFileSizeExceed = true;
            else IsFileSizeExceed = false;
          }
          if (IsFileSizeExceed) {
            this.toastr.error(this.translate.instant("SETTING.FileSize"), 'Error');
            $("#in_cprd_uploadProduct").val("");
            Helpers.setLoading(false);
            return;
          }
          //----------------------------------------------

          this.company = this.Company.Id;
          var fd = new FormData();
          var file = this.selectFile;
          if (fd.has("cprd_uploadProduct")) {
            fd.set("cprd_uploadProduct", this.selectFile);
          } else {
            fd.append("cprd_uploadProduct", this.selectFile);
          }
          var body = fd;
          var headers = new Headers();
          let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieservice.get("user_access_token")));
          const token: string = "Bearer " + user_access_token;
          headers.append("Authorization", token);
          let options = new RequestOptions({ headers: headers });

          const apiUrl = environment.apiUrl + "/api/Network/cprd_uploadProductData?UserId=" + this.userId + "&CompanyId=" + this.EditD2D;
          const req1 = this.anghttp.post(apiUrl, body, options).map((response: Response) => response.json()).subscribe((response) => {
            Helpers.setLoading(false);
            $("#in_cprd_uploadProduct").val("");
            if (response == "OK") {
              this.toastr.success("Data uploaded successfully !", "Success");
              this.ProductDataTable.reload();
            }
            else {
              this.DownloadFile(response);
              this.toastr.error("Please check downloaded file...", "error");
            }
          },
            (err) => {
              Helpers.setLoading(false);
              this.toastr.error("Error occurred while upload Data !", "error");
              $("#in_cprd_uploadProduct").val("");
            }
          );
        }
      }, 300);

    } else {
      this.toastr.error("Please Fill Basic Information!", "Required");
      $("#divtopbar_companyInfo,#topbar_companyInfo").addClass("active");
      $("#divtopbar_Product, #topbar_Product").removeClass("active");
    }
  }
}
